
import React, { useState, useCallback, useEffect } from "react";
import { connect, withFormik } from 'formik';
import * as Yup from "yup";
import moment from "moment"
import { useTranslation } from 'react-i18next';
import { useStoreState, useStoreActions } from 'easy-peasy';

// Storybook
import { Button, Typography, Spinner } from "stories/components";
import { Container, Row, Col, FormContainer, Card, CardBody } from "stories/layout";
import { Input, SelectMulti, Toggle, Radio, DatePicker, Checkbox } from "stories/forms";

import { useNotification } from "stories/components/Notification"

// App
import { round ,roundScaleDecimals, thousandFormat} from "services/helpers"

import OptionRightInput from "components/Forms/OptionRightInput/OptionRightInput"
import OptionAssetTypeInput from "components/Forms/OptionAssetTypeInput/OptionAssetTypeInput"
import OptionStateInput from "components/Forms/OptionStateInput/OptionStateInput"
import StockSelect from "components/Forms/StockSelect/StockSelect"
import StockPrivateSelect from "components/Forms/StockPrivateSelect/StockPrivateSelect"
import CommissionSelect from "components/Forms/CommissionSelect/CommissionSelect"
import PortfolioSelectStore from "components/Forms/PortfolioSelect/PortfolioSelectStore"
import StockMarketSelect from "components/Forms/StockMarketSelect/StockMarketSelect"
import BatchSelect from "components/Forms/BatchSelect/BatchSelect"
import InvestmentTypeSelect from "components/Forms/InvestmentTypeSelect/InvestmentTypeSelect"
import InvestmentTypeSelectSub from "components/Forms/InvestmentTypeSelectSub/InvestmentTypeSelectSub"
import UpdateUp from "views/vismapay/UpdateUp/UpdateUp"

import HelpText from "components/Info/HelpText.js"
import ImageWithPolygons from 'components/ImageWithPolygons/ImageWithPolygons';
import PdfWithPolygons from "components/PdfWithPolygons/PdfWithPolygons";



import CurrencySelect from "components/Forms/CurrencySelect/CurrencySelect"
import { httpGetStockData } from "services/stocks"

import { httpGetPrivateStockDatas } from "services/private_stocks"
import { 
  httpGetTransaction, 
  httpGetTransactions, 
  httpCreateTransaction, 
  httpUpdateTransaction, 
  httpDeleteTransaction, 
  httpGetStockDateBalance, 
  httpCreatePrivateStockTransaction, 
  httpUpdatePrivateStockTransaction,
  httpDeletePrivateStockTransaction,
  httpGetPrivateStockDateBalance,
  httpGetPrivateStockTransaction,
  httpGetPrivateStockTransactions,
  httpGetCurrentBatchBalanceRatio,
  httpUpdatePreTransaction
} from "services/transactions"

import { 
  httpGetPrivateInvestimentFundDatas
} from "services/private_investment_funds";

import {httpGetInvestmentFundData} from "services/investment_fund";


import { httpGetCurrencyRate } from "services/currencies"
import { set, startOfDay } from "date-fns";
import { de } from "date-fns/locale";

import TransactionsFileHandling from "components/Forms/TransactionsFileHandling/TransactionsFileHandling"
import {
  httpUploadFiles,
  httpCreateFileAiMessages
} from "services/files"
import UploadFile from "components/Forms/UploadFile/UploadFile"

import AllSecuritySelect2 from "components/Forms/AllSecuritySelect/AllSecuritySelect2"
import TransactionTypeSelect from "components/Forms/TransactionTypeSelect/TransactionTypeSelect"




let today_date = new Date()
today_date.setHours(12, 0, 0, 0);

const defaultValues = {
  id: null,
  fifo_used: true,
  stock: null,
  stock_private_obj: null,
  batch_select: null,
  date_transaction: null,
  date_settlement: null,
  broker_name: null,
  reference_code: null,
  notes: null,
  currency: null,
  commission: null,
  commission_total: null,
  quantity: null,
  price: null,
  price_total: null,
  ai_comments: null,
}

const PurchaseEdit = (props) => {
  
  const {
     values,
     touched,
     errors,
     handleChange,
     handleBlur,
     handleSubmit,
     setFieldValue,
     setFieldError,
     setFieldTouched,
     isValid,
     isTouched,
     isSubmitting,
     validateForm,
     preSetValues,
     objectId,
     setValues,
     setErrors,
      setTouched,
   } = props;
   
   const {
      t,
      history,
      currencyDate,
      setCurrencyDate,
      securityTargetRate,
      setSecurityTargetRate,
      portfolioSourceRate,
      setPortfolioSourceRate,
      securitySourceRateDate,
      setSecuritySourceRateDate,
      stocks,
      stockMarket,
      setStockMarket,
      setInvestmentType,
      investmentType,
      fundType,
      setFundType,
      setFilters,
      totalValue,
      setTotalValue,
      totalValueEur,
      setTotalValueEur,
      stocksLoading,
      setCurrentStock,
      setBatchs,
      batchs,
      portfolio,
      batchRatio,
      setBatchRatio,
      transaction_count,
      maxSaldo,
      setMaxSaldo,
      setBatchWac,
      batchWac,
      setFiles,
      files,
      handleFileUpload,
      trxFiles,
      setTrxFiles,
      object,
      setTransactionType,
      transactionType,
 } = props;
   
 const getFormikInputProps = useCallback(
    name => ({
      name,
      value: values[name],
      error: Boolean(touched[name] && errors[name]),
      errorText: touched[name] ? errors[name] : "",
      onBlur: handleBlur,
      onChange: handleChange
    }),
    [values, errors, touched, handleBlur, handleChange]
  );
  const account = useStoreState((state) => state.account?.account);
  
  const [stockDatePrice, setStockDatePrice] = useState();
  const [stockDatePriceLoading, setStockDatePriceLoading] = useState(false);
  const [batch , setBatch] = useState(null);
  const [isSelectOpen,setIsSelectOpen] = useState(false);
  const [firstTimeQuantity, setFirstTimeQuantity] = useState(false);
  
  const [stockTickerSymbol, setStockTickerSymbol] = useState(null);


  const [calculatePriceClicked, setCalculatePriceClicked] = useState(false);
  const [calculatePriceTotalClicked, setCalculatePriceTotalClicked] = useState(false);
  const [securityCurrencyChanged, setSecurityCurrencyChanged] = useState(false);
  const [dateTransactionChanged, setDateTransactionChanged] = useState(false);
  const [dateTransactionChangedFirstTime, setDateTransactionChangedFirstTime] = useState(true);

  const [price_rate, setPriceRate] = useState(null);
  const [price_rate_loading, setPriceRateLoading] = useState(false);
  const [price_total_rate, setPriceTotalRate] = useState(null);
  const [price_total_rate_loading, setPriceTotalRateLoading] = useState(false);
  const [commission_rate, setCommissionRate] = useState(null);
  const [commission_rate_loading, setCommissionRateLoading] = useState(false);
  
  const getBasicDataObjects = useStoreActions((actions) => actions.stocks.getObjects);
  const getPrivateBasicDataObjects = useStoreActions((actions) => actions.privateStocks.getObjects);
  const privateStocks = useStoreState((state) => state.privateStocks?.objects);
  
  const onSubmit = (e) => {
    e.preventDefault();
    validateForm().then(res => {
      if (Object.keys(res).length === 0) {
        handleSubmit()
      }
      else {
        setTouched(res);
        if (stockMarket === "PRIVATE") {

          setErrors({
            ...res,
            stock_private_obj: res?.stock_private_obj?.id ? res?.stock_private_obj?.id : t("Kenttä on pakollinen"),
            general: t("Please check the form errors", "Tarkista lomakkeen virheet, Osake")
          })
        }
        else {
          setErrors({
            ...res,
            stock: res?.stock?.id ? res?.stock?.id : t("Kenttä on pakollinen"),
            general: t("Please check the form errors", "Tarkista lomakkeen virheet")
          })
        }
      }
    })
  }

  const convertToPortfolioCurrency = (value, given_rate, target_field) => {
    const rate = roundScaleDecimals(given_rate/portfolioSourceRate, 3)
    //set values to formik
    setFieldValue(target_field, roundScaleDecimals(value*rate, 4))
    // return roundScaleDecimals(value*rate, 4)
  }

  const findStockObject = useCallback ((id) => {
    // const filteredObjects = stocks && stocks.filter(o => o.id === id)
    // if (filteredObjects && filteredObjects.length > 0) {
    //   return filteredObjects[0]
    // }
    // return null
    let filteredObjects = null
    if (stockMarket === "PRIVATE") {
      filteredObjects = privateStocks && privateStocks.filter(o => o.id === id)
    }
    else {
      filteredObjects = stocks && stocks.filter(o => o.id === id)
    }

    if (filteredObjects && filteredObjects.length > 0) {
      return filteredObjects[0]
    }
    return null
  }, [stocks, stocksLoading])


  useEffect(() => {
    if (portfolio.sell_profit_calculation_method=="WAC"){
      setFieldValue("fifo_used", false)
    }

    },[])

  useEffect(() => {
    let currency = portfolio?.currency_label


    setFieldValue("currency", currency )
  }, [portfolio, values?.stock, stocks])


  useEffect(() => {
    if (values?.type != transactionType){
      setTransactionType(values?.type)
    }
  }, [values?.type])


  //----------------------------UPDATE BASICDATA when stock market change----------------------------------------------------
  useEffect(() => {
    if (investmentType) {
      console.log("PRIVATE basic_data")
      // getPrivateBasicDataObjects()

      let param ={
        stock_market:stockMarket,
        related_model_type: investmentType,
        portfolio_batches_stock: portfolio?.id,
        show_hidden: true
      }

      if (investmentType == "30" ){
        param ={...param, type: fundType}
      }
      getBasicDataObjects(param)
    }
    else {
    getBasicDataObjects({stock_market:stockMarket, show_hidden: true})
    }
    // if (values)
    // setFieldValue('stock', null)
  }, [stockMarket, investmentType,fundType ])
  
  useEffect(() => {
    setFieldValue("batch_select", null)
    setBatchs([])
    setBatch(null)
    setBatchWac({
      batch_select_wac: []
    })
    if (!objectId){
      setFieldValue("stock", null)
    }
    setStockTickerSymbol(null)

  }, [portfolio])
  
  //----------------------------Show user that date settlement changed ----------------------------------------------------

    useEffect(() => {

      if (dateTransactionChanged && values?.date_transaction ) {
        setTimeout(() => {
          setDateTransactionChanged(false);
        }, 1000);
      }
      else if (dateTransactionChangedFirstTime) {
        setDateTransactionChangedFirstTime(false)
      }
    }, [dateTransactionChanged])

  //----------------------------UPDATE totalValue STATE----------------------------------------------------
  useEffect(() => {
    const price_total = parseFloat(values?.price_total || 0)
    let commission_total = parseFloat(values?.commission_total || 0)

    // For sale transactions (type 3), commission should be negative
    if (values?.type == 3) {
      commission_total = -Math.abs(commission_total)
    } else {
      // For purchase transactions (type 2), commission should be positive
      commission_total = Math.abs(commission_total)
    }

    // Always add commission to get total cost
    setTotalValue(round(price_total + commission_total, 2))
    
  }, [values?.price_total, values?.commission_total, values?.type])
  
  /* Optional: if you want to calc price reversed
  useEffect(() => {
    const price_total = parseFloat(values?.price_total)
    const quantity = parseInt(values?.quantity)
    let calculation = 0
    if (price_total && price_total > 0 && quantity && quantity > 0) {
      calculation = price_total / quantity
    }
    if (calculation && calculation != parseFloat(values?.price)) {
      setFieldValue("price", calculation)
    }
  }, [values?.price_total, values?.quantity])
  */
  

  //----------------------------UPDATE TOTAL PRICE Automatically ----------------------------------------------------


  const handleCalculatePriceTotal = () => {
    setCalculatePriceClicked(false)
    setCalculatePriceTotalClicked(true)
    const quantity = parseFloat(values?.quantity)
    const price = parseFloat(values?.price)
    let calculation = 0
    if (price && quantity && price > 0 && quantity > 0) {
      calculation = price*quantity;
    }
    if (calculation && calculation !== parseFloat(values?.price_total)) {
      setFieldValue("price_total", parseFloat(roundScaleDecimals(calculation, 6)))
    }
    setTimeout(() => {
      setCalculatePriceTotalClicked(false);
    }, 1000);
  }

  useEffect(() => {
    // handleCalculatePriceTotal()
  }, [values?.price, values?.quantity])

    //----------------------------Calculate PRICE based on value_total and quantity ----------------------------------------------------


    const handleCalculatePrice = () => {
      setCalculatePriceClicked(true)
      setCalculatePriceTotalClicked(false)
      const quantity = parseFloat(values?.quantity)
      const price_total = parseFloat(values?.price_total)
      let calculation = 0
      setTimeout(() => {
        setCalculatePriceClicked(false);
      }, 1000);
      if (price_total && quantity ) {
        calculation = price_total /quantity;
      }
      else {return}
      setFieldValue("price", parseFloat(roundScaleDecimals(calculation, 6)))
    }
  


  //----------------------------UPDATE STOCK PRICE  {values.stock.id}----------------------------------------------------

  const findObject = (id) => {
    let filteredObjects = null
    if (stockMarket === "PRIVATE") {
      filteredObjects = privateStocks && privateStocks.filter(o => o.id === id)
    }
    else {
      filteredObjects = stocks && stocks.filter(o => o.id === id)
    }
    if (filteredObjects && filteredObjects.length > 0) {
      return filteredObjects[0]
    }
    return null
  }

  useEffect(() => {
    let stockObject = findObject( stockMarket === "PRIVATE"? values?.stock_private_obj :values?.stock?.id)

    let ticker_symbol = undefined
    let stock_market = values?.stock_market
    let nasdaq_id =values?.nasdaq_id; // "ACG1V";
    if (stockObject) {
      nasdaq_id = stockObject?.nasdaq_id
      stock_market = stockObject?.stock_market
      if (stockObject?.ticker_symbol){
        ticker_symbol = stockObject?.ticker_symbol
        setStockTickerSymbol(stockObject?.ticker_symbol)
      }
      else {
        setStockTickerSymbol(stockObject?.symbol)
      }
    }
    else {
      setStockTickerSymbol(null)
    }
    if ((values?.stock && values?.date_transaction  && firstTimeQuantity)|| (values?.stock_private_obj && values?.date_transaction)) {
      const stock_date = undefined; // moment("2021-12-28").toISOString().split('T')[0] +" 00:00"; // "2021-12-27";
      let params = {
        offset:0, 
        limit:1, 
        // stock_date: "2021-12-26", // this exact filter not working
        // ticker_symbol: ticker_symbol,
        nasdaq_id: nasdaq_id,
        stock_market: stock_market,
      }
      
      // Stock date

      if (stockMarket === "PRIVATE") {
        // params["stock_date__gte"] = moment.utc(values?.date_transaction).startOf('day').toDate()
        // console.log(params["stock_date__gte"])
        // params["stock_date__lte"] = moment(values?.date_transaction).add("days",1).toISOString().split('T')[0] +" 23:59"; 
        
        // params["private_stock"] = values?.stock_private_obj?.id

        // httpGetPrivateStockDatas(params).then(res => {
        //   console.log("httpGetPrivateStockData res",res)
        //   if (res?.data?.count > 0) {
        //     setStockDatePrice(parseFloat(round(res?.data?.results[0]?.price, 2).toFixed(2)))
        //   }
        //   else {
        //     setStockDatePrice(null)
        //   }
        // })
      }
      else {
        params["stock_date__gte"] = moment(values?.date_transaction).toISOString().split('T')[0] +" 00:00:00Z"; 
        params["stock_date__lte"] = moment(values?.date_transaction).toISOString().split('T')[0] +" 23:59"; 

        if (investmentType == "10" && ticker_symbol){
          params["ticker_symbol"] = null;
          setStockDatePriceLoading(true)
          httpGetStockData(params).then(res => {
            if (res?.data?.count > 0) {
              setStockDatePrice(parseFloat(round(res?.data?.results[0]?.ending_price,2).toFixed(2)))
              setStockDatePriceLoading(false)
              
            }
            else {
              setStockDatePrice(null)
              setStockDatePriceLoading(false)
              
            }
          })
        }
        if (investmentType == "20"){
          params["private_stock"] = values?.stock?.id;

          setStockDatePriceLoading(true)
          httpGetPrivateStockDatas(params).then(res => {
            if (res?.data?.count > 0) {
              setStockDatePrice(parseFloat(round(res?.data?.results[0]?.price,2).toFixed(2)))
              setStockDatePriceLoading(false)
              
            }
            else {
              setStockDatePrice(null)
              setStockDatePriceLoading(false)
              
            }
          })
        }
        if (investmentType == "30"){
          params["private_investment_fund"] = values?.stock?.id;
          params["date__gte"] = moment(values?.date_transaction).toISOString().split('T')[0] +" 00:00:00Z"; 
          params["date__lte"] = moment(values?.date_transaction).toISOString().split('T')[0] +" 23:59"; 
          setStockDatePriceLoading(true)
          httpGetPrivateInvestimentFundDatas(params).then(res => {
            if (res?.data?.count > 0) {
              setStockDatePrice(parseFloat(round(res?.data?.results[0]?.price,2).toFixed(2)))
              setStockDatePriceLoading(false)
              
            }
            else {
              setStockDatePrice(null)
              setStockDatePriceLoading(false)
              
            }
          })
        }

        if (investmentType == "40"){
          params["investment_fund"] = values?.stock?.id;
          params["date__gte"] = moment(values?.date_transaction).toISOString().split('T')[0] +" 00:00:00Z"; 
          params["date__lte"] = moment(values?.date_transaction).toISOString().split('T')[0] +" 23:59"; 
          setStockDatePriceLoading(true)
          httpGetInvestmentFundData(params).then(res => {
            if (res?.data?.count > 0) {
              setStockDatePrice(parseFloat(round(res?.data?.results[0]?.price,2).toFixed(2)))
              setStockDatePriceLoading(false)
              
            }
            else {
              setStockDatePrice(null)
              setStockDatePriceLoading(false)
              
            }
          })
        }


        // let batchsParams = {
          
        //   stock_market: investmentType != 10? null: stockMarket,
        //   related_model_id: values?.stock?.id,
        //   related_model_type: investmentType,
        //   portfolio: portfolio?.id,  
        //   ordering: "date_transaction",
        // }

        // httpGetTransactions(batchsParams).then(res => {
        //   //filter res.data.results by batch_balance > 0

        //   //
        //   if (res?.data?.length > 0) {
        //     const filteredResults = res?.data?.filter(result => result.batch_balance > 0);
        //     setBatchs(filteredResults)
        //     setBatch(filteredResults[0])
        //     setFieldValue("batch_select", null)
        //   }
        //   else {
        //     setBatchs([])
        //     setBatch(null)
        //     setFieldValue("batch_select", null)

        //   }

        //   // setBatchs(res?.data?.results)
        //   // setCount(res?.data?.count)
  
        //   //   setLoading(false)
          
        // })

        // batchsParams["batch_select"] = values?._wac?.id
        // httpGetCurrentBatchBalanceRatio(batchsParams).then(res => {
        //   setBatchRatio(res?.data)
        // })

      }
    }
  }, [values?.stock, values?.stock_private_obj, values?.date_transaction, firstTimeQuantity])

    //Get stock date price only when stock date change or stock change but only ones/frist time when quantity change
    useEffect(() => {
      if (values?.quantity && firstTimeQuantity == false) {
        setFirstTimeQuantity(true)
      }
    }, [values?.quantity])

  useEffect(() => {

    if (values?.stock){

    let batchsParams = {
          
      stock_market: investmentType != 10? null: stockMarket,
      related_model_id: values?.stock?.id,
      related_model_type: investmentType,
      portfolio: portfolio?.id,  
      ordering: "date_transaction",
      type:2,
      wac_date_lte: values?.wac_date_lte ? moment(values?.wac_date_lte).set({hour: 12, minute: 0, second: 0, millisecond: 0}).format() : undefined,
      wac_date_gte: values?.wac_date_gte ? moment(values?.wac_date_gte).set({hour: 12, minute: 0, second: 0, millisecond: 0}).format() : undefined,
    }

    httpGetTransactions(batchsParams).then(res => {
      //filter res.data.results by batch_balance > 0

      //
      if (res?.data?.length > 0) {
        const filteredResults = res?.data?.filter(result => result.batch_balance > 0);
        setBatchs(filteredResults)
        setBatch(filteredResults[0])
        setBatchWac({
          batch_select_wac: []
        })
        !objectId && setFieldValue("batch_select", null)
      }
      else {
        setBatchs([])
        setBatch(null)
        setBatchWac({
          batch_select_wac: []
        })
        setFieldValue("batch_select", null)

      }

      // setBatchs(res?.data?.results)
      // setCount(res?.data?.count)

      //   setLoading(false)
      
    })
    if (values?.type == 3){
        batchsParams["batch_select"] = values?.batch_select?.id
        httpGetCurrentBatchBalanceRatio(batchsParams).then(res => {
        setBatchRatio(res?.data)
        setBatchWac({
            batch_select_wac: []
        })
        })
    }
  }


  }, [values?.stock, values?.stock_private_obj, values?.wac_date_lte, values?.wac_date_gte])

  // useEffect(() => {
  //   let batchsParams = {
          
  //     stock_market: stockMarket,
  //     related_model_id: values?.stock?.id,
  //     related_model_type: investmentType,
  //     portfolio: portfolio?.id,  
  //     ordering: "date_transaction",
  //     _wac: values?._wac
  //   }
  //   if (values?._wac !== null) {
  //   httpGetCurrentBatchBalanceRatio(batchsParams).then(res => {
  //     console.log("httpGetCurrentBatchBalanceRatio res",res)
  //     if (res?.data) {
  //       setBatchRatio(res?.data?.ratio)
  //     }
  //     else{
  //       setBatchRatio(1)
  //     }
  //   })

  //   }
  // }, [values?._wac])


  



  useEffect(() => {
    if (values?.stock || values.stock_private_obj) {
      let stockObject = findObject(values?.stock?.id)
      if (stockObject) {
        if (stockMarket === "PRIVATE") {
          setFieldValue("stock_private_obj", {...values.stock_private_obj, label: stockObject?.name})
        }
        else {
        setFieldValue("stock", {...values.stock, label: stockObject?.name})
        
        }
      }
    }
  }, [stocks])


  //---------------------------UPDATE date_settlement if date_transaction are changed----------------------------------------------------
  //   useEffect(() => {
  //     if (!objectId){
  //     setFieldValue("date_settlement", values?.date_transaction)
  //     }
  // }, [values?.date_transaction])

  

  
  //---------------------------- Update subscription BEGIN---------------------------------

  const openUpdateUp = useCallback(() => {
    return (<>{(account?.license?.limit_transactions <= transaction_count && objectId == null) && <UpdateUp redirectToFrontpage={false} forceOpen={account?.license?.limit_transactions <= transaction_count}/>}</>)
  }, [account?.license])

  // Update subscription END

  //------------------------UPDATE COMISSION TOTAL-----------------------------------------------
  useEffect(() => {
    const price_total = parseFloat(values?.price_total)
    const commission = parseInt(values?.commission)
    if (price_total && price_total > 0 && commission && commission > 0) {
      if (commission === 2) {
        setFieldValue("commission_total", 0)
      }
      else if (commission === 3) {
        const commission_total = 8.0
        setFieldValue("commission_total", round(commission_total,2))
      }
      else if (commission === 4) {
        const commission_total = round(8.0 + (0.025*price_total), 2)
        setFieldValue("commission_total", round(commission_total,2))
      }
      
    }
    else {
      // setFieldValue("commission_total", 0)
    }
  }, [values?.price_total, values?.commission])
  


  // ------------------UPDATE CURRENCY DATE-----------------------------------
  useEffect(() => {
    console.log("values?.currency",values?.currency, values?.date_transaction)
    if (values?.currency && values?.date_transaction) {
      
      if (values?.currency === "EUR") {
        setPortfolioSourceRate(1.0)
      }
      else {
        // Use AI-provided exchange rate if available, otherwise fallback to API
        if (values?.currency_exchange_rate && values?.currency_exchange_rate !== 1) {
          setPortfolioSourceRate(values?.currency_exchange_rate)
        } else {
          let params = {
            offset:0, 
            limit:1, 
          }
          params["Date"] = moment(values?.date_transaction).format("YYYY-MM-DD")
          params['currency'] = values?.currency
          httpGetCurrencyRate(params).then(res => {
            if (res?.data?.currency_rate) {
              setPortfolioSourceRate(res?.data?.currency_rate)
            }
            else {
              setPortfolioSourceRate(1.0)
            }
          }, err => {
            setPortfolioSourceRate(null)
          })
        }
      }
    }
    else {
      setPortfolioSourceRate(null)
    }
  }, [values?.currency, values?.date_transaction, values?.currency_exchange_rate])

  useEffect(() => {
    if (securityTargetRate && portfolioSourceRate){

      setCurrencyDate(parseFloat(roundScaleDecimals(securityTargetRate/portfolioSourceRate, 6)))
    }
    else{
      setCurrencyDate(null)
    }

  }, [securityTargetRate, portfolioSourceRate])
  


  // ------------------UPDATE TOTAL VALUE EUR-----------------------------------
  useEffect(() => {
    // Convert from portfolio currency to security currency using exchange rate
    if (values?.currency_exchange_rate && values?.currency_exchange_rate !== 1 && totalValue) {
      // If we have AI exchange rate, use it to convert back to original currency
      // Use REVERSE operation: if direction is 'divide', multiply; if 'multiply', divide
      const direction = values?.currency_exchange_rate_direction || 'multiply';
      if (direction === 'divide') {
        setTotalValueEur(round(totalValue * values?.currency_exchange_rate, 2))
      } else {
        setTotalValueEur(round(totalValue / values?.currency_exchange_rate, 2))
      }
    }
    else if (currencyDate && totalValue && currencyDate !== 1) {
      // Fallback to old currency conversion
      setTotalValueEur(round(totalValue / currencyDate, 2))
    }
    else {
      setTotalValueEur(totalValue)
    }
      
  }, [currencyDate, totalValue, values?.currency_exchange_rate, values?.currency_exchange_rate_direction])
  

  // -------------------------SET PRICE automatically if in field have no value already--------------------------------------------
  useEffect(() => {
    // if (!values.price) {
    //   handleUseStockDatePrice()
    // }
    // handleUseStockDatePrice()
  }, [stockDatePrice])
            



  // ------------------fUCTIONS TO USE-----------------------------------

  const handleCancel = () => {
    props.handleReject()
  }
  
  const handleConfirm = () => {
    /*
    httpConfirmPurchaseOrderShipping(values?.id).then(res => {
      handleSubmit()
    })
    */
  }

  useEffect(() => {
      
    if (values?.stock && values?.date_transaction) {
      const security_currency = getStockCurrency()
      let params = {
        offset:0, 
        limit:1, 
        // ordering: '-Date'

      }
      // Use AI-provided exchange rate if available, otherwise fallback to API
      if (values?.currency_exchange_rate && values?.currency_exchange_rate !== 1 && security_currency !== "EUR") {
        setSecurityTargetRate(values?.currency_exchange_rate)
        setSecuritySourceRateDate("AI")
      } else {
        params["Date"] = moment(values?.date_transaction).format("YYYY-MM-DD")
        params['currency'] = security_currency
        httpGetCurrencyRate(params).then(res => {
            if (res?.data?.currency_rate) {
              setSecurityTargetRate(res?.data?.currency_rate)
              setSecuritySourceRateDate(res?.data?.currency_date)
            }
            else {
              setSecurityTargetRate(1.0)
              setSecuritySourceRateDate(null)
            }
          }, error => {
            setSecurityTargetRate(null)
            setSecuritySourceRateDate(null)
          })
      }



        if (values?.original_price_currency){
            // Use AI-provided exchange rate if available, otherwise fallback to API
            if (values?.currency_exchange_rate && values?.currency_exchange_rate !== 1 && values?.original_price_currency !== "EUR") {
                setPriceRate(values?.currency_exchange_rate)
            } else {
                let params = {
                    offset:0, 
                    limit:1, 
                }
                params["Date"] = moment(values?.date_transaction).format("YYYY-MM-DD")
                params['currency'] = values?.original_price_currency
                httpGetCurrencyRate(params).then(res => {
                    if (res?.data?.currency_rate) {
                    setPriceRate(res?.data?.currency_rate)
                    }
                    else {
                    setPriceRate(1)
                    }
                }, error => {
                    setPriceRate(null)
                })
            }
        }
        if (values?.original_price_total_currency){
            // Use AI-provided exchange rate if available, otherwise fallback to API
            if (values?.currency_exchange_rate && values?.currency_exchange_rate !== 1 && values?.original_price_total_currency !== "EUR") {
                setPriceTotalRate(values?.currency_exchange_rate)
            } else {
                let params = {
                    offset:0, 
                    limit:1, 
                }
                params["Date"] = moment(values?.date_transaction).format("YYYY-MM-DD")
                params['currency'] = values?.original_price_total_currency
                httpGetCurrencyRate(params).then(res => {
                    if (res?.data?.currency_rate) {
                    setPriceTotalRate(res?.data?.currency_rate)
                    }
                    else {
                    setPriceTotalRate(1)
                    }
                }, error => {
                    setPriceTotalRate(null)
                })
            }
        }
        if (values?.original_commission_total_currency){
            // Use AI-provided exchange rate if available, otherwise fallback to API
            if (values?.currency_exchange_rate && values?.currency_exchange_rate !== 1 && values?.original_commission_total_currency !== "EUR") {
                setCommissionRate(values?.currency_exchange_rate)
            } else {
                let params = {
                    offset:0, 
                    limit:1, 
                }
                params["Date"] = moment(values?.date_transaction).format("YYYY-MM-DD")
                params['currency'] = values?.original_commission_total_currency
                httpGetCurrencyRate(params).then(res => {
                    if (res?.data?.currency_rate) {
                    setCommissionRate(res?.data?.currency_rate)
                    }
                    else {
                    setCommissionRate(1)
                    }
                }, error => {
                    setCommissionRate(null)
                })
            }
        }
       


    }else {
      setSecurityTargetRate(null)
      setSecuritySourceRateDate(null)
    }
  }, [values?.stock, stocksLoading, values?.date_transaction, values?.currency_exchange_rate])



  const getStockCurrency = useCallback(() => {
    // const stock = findStockObject(values?.stock?.id)
    let stock = values?.stock
    // if (objectId || object){
    //   stock = findStockObject(values?.stock?.id)
    // }
    let currency = null
    if (stock?.currency_label){
      currency = stock?.currency_label
    }
    else if (stock?.currency){
      currency = stock?.currency
    }
    else if (stock?.trading_currency){
      currency = stock?.trading_currency
    }
    return currency
  }, [values?.stock])



  const handleStockMarketChange = ({target}) => {
    setStockMarket(target.value)
    setFieldValue("stock", null)
    setFieldValue("stock_private_obj", null)
    setStockTickerSymbol(null)
    setStockDatePrice(null)
    setBatchs([])
    setBatch(null)
    setBatchWac({
      batch_select_wac: []
    })
    setFieldValue("batch_select", null)
    setBatchRatio([])


    if (target.value === "PRIVATE") {
      
      setErrors({
        ...errors,
        stock_private_obj: t("Kenttä on pakollinen"),
      })
    }
    else {
      setErrors({
        ...errors,
        stock: t("Kenttä on pakollinen"),
      })
    }

  }

  const handleBatchChange = ({target}) => {
    setBatch(target.value)
    setFieldValue("batch_select", target.value)

  }

  const handleBatchMultiChange = (name, value) => {
    setBatchWac(s => ({
      ...s,
      [name]: value
  }))
  }

  const handleFundChange = ({target}) => {
    setFundType(target.value)   
    setFieldValue("stock", null)
  } 


  const handleInvestmentTypeChange = ({target}) => {
    if (target.value === "10") {
      setStockMarket("XHEL")
      // setFilters(s => ({
      //   ...s,
      //   related_model_type: "10",
      // }))
      setInvestmentType(target.value)   
      setFieldValue("stock", null)
      setFieldValue("stock_private_obj", null)
      setStockTickerSymbol(null)
      setStockDatePrice(null)
      setFieldValue("batch_select", null)

      setBatchs([])
      setBatch(null)
      setBatchWac({
        batch_select_wac: []
      })
      setBatchRatio([])

    }
    else {
      setStockMarket(null)
      setInvestmentType(target.value)
      // setFilters(s => ({
      //   ...s,
      //   // related_model_type: target.value,
      //   // stock_market: null,
      // }))
      setFieldValue("stock", null)
      setFieldValue("stock_private_obj", null)
      setFieldValue("batch_select", null)
      setStockTickerSymbol(null)
      setStockDatePrice(null)
      setBatchs([])
      setBatch(null)
      setBatchWac({
        batch_select_wac: []
      })
      setBatchRatio([])
    }
  } 

  const getBatchObj = useCallback ((id) => {
    //loop all batchRatio and find the one with the same id
    // console.log("batchRatio", batchRatio)
    let balance = null;
    if (batchRatio?.[0]?.id)  {
      // console.log("batch------")
      batchRatio && batchRatio.map(obj => {
      if (obj.id == id) {
        balance = obj.batch_balance;
      }
    })  
    }
    // console.log(ratio)
    return balance;
  }, [batchRatio, batchWac])
  
  const getBatchesBalance = useCallback(() => {
    let sumBalance = 0;
    if (batchRatio?.[0]) {
      if (batchWac?.batch_select_wac?.length > 0) {
        batchWac.batch_select_wac.forEach((obj) => {
          const b = getBatchObj(obj?.id);
          sumBalance += b != null ? Number(b) : 0;
        });
      } else {
        batchRatio.forEach((obj) => {
          sumBalance += obj?.batch_balance != null ? Number(obj.batch_balance) : 0;
        });
      }
    }
    return sumBalance;
  }, [batchRatio, batchWac, getBatchObj]);

  useEffect(() => {
    const sumBalance = getBatchesBalance();
    setMaxSaldo(roundScaleDecimals(sumBalance, 6));
  }, [getBatchesBalance, setMaxSaldo]);

  const getDefaultValues = useCallback(() => {
    // if (location?.state?.stockId && !values?.private_stock && !values?.stock==="stock_market_changed") {
    //   return {value: location.state?.stockId, label: location.state?.stockName}
    // }
    if (values?.stock_market === "PRIVATE") {
    return {value: values?.private_stock, label: values?.private_stock_name }
    }
    return {value: values?.stock, label: values?.stock_name }
  }, [values])

  
  const handleUseStockDatePrice = () => {
    if (stockDatePrice && !objectId) {
      setFieldValue("price", Number(stockDatePrice.toFixed(2)))
    }
  }


  
  const handlePass = () => {
        const pre_update_data ={
            id: object?.id,
            portfolio: object?.portfolio,
            processed: true,
        }
        httpUpdatePreTransaction(pre_update_data ).then(res => {
            console.log("httpUpdatePreTransaction", res)
            props.handleResolve()
        }, error => {
            console.log("httpUpdatePreTransaction error", error)
            props.handleResolve()
        }
        )

    //   httpDeleteTransaction(values?.id).then(res => {
    //     props.notify({ title:t("Kirjaus"), message:t("Poistettu")})
    //     if (investmentType == "10"){
    //       setFilters(s => ({
    //           ...s,
    //           stock_market: null,
    //           related_model_type: null,
    //         }))
    //   }
    //   else {
    //       setFilters(s => ({

    //           ...s,
    //           stock_market: null,
    //           related_model_type: null,
    //         }))
    //   }
    //     props.handleResolve()
    //   }, error => {
    //     console.log("httpCreateStockTransaction error", error);
    //     props.notify({ title:t("Kirjaus"), message:t("Poisto epäonnistui")})

    //     if (error?.status === 400) {
    //       setErrors(error?.data)
    //     }
    //     else {
    //       setErrors({
    //         general: t("Tuntematon virhe. Yritä myöhemmin uudelleen tai ota yhteys tukeen.")
    //       })
    //     }
        
    //   })
  }

  const onChangeBatch = ({target}, child) => {
    if (target?.value > 0) {
      const filtered = batchs.filter(o => o.id == target?.value)
      if (filtered && filtered.length > 0) {
        setBatch(filtered[0])
      }
    }
    if (target?.value === ""){
      setBatch("")
    }
  }

  const getBatch = useCallback((id) => {
    // return batchs.find(o => o.id === id)
    id = Number(id)
    return batchs.find(o => o.id === id)
  }, [values.batch_select])


  


  const getStockSelect = useCallback(() => {
    if (stockMarket === "PRIVATE") {
      return (
        <StockPrivateSelect
          {...getFormikInputProps("stock_private_obj")}
          label={t("pre_transaction_edit_asset_stock", "Osake (yksityinen)")}
          setFieldValue={setFieldValue}
          setValueToSelect={true}
          ratesView={false}
          setFieldValueReturnId={false}

        />
      )
    }
    else {
      return (
        <div name="stock_select_click" className={values?.security_name_polygon.length > 0?"border-yellow" :""}>
        <StockSelect
          {...getFormikInputProps("stock")}
          label={t("purchase_order_edit_asset_stock-", "Arvopaperi *")}
          setFieldValue={setFieldValue}
          setFieldTouched={setFieldTouched}
          loading={stocksLoading}
          setValues={setValues}
          setFieldValueReturnId={false}
          ratesView={false}
          setValueToSelect={true} 
          disabled={objectId?true:false}
          setIsSelectOpen={setIsSelectOpen}
          isSelectOpen={isSelectOpen}
          id="stock"
          async={true}
        />
        </div>
      )
    }
  }, [investmentType, stockMarket, values?.stock, values.stock_private_obj, errors?.stock, errors?.stock_private_obj, errors, values?.security_name_polygon])


  //----------------------------Show user that security currency changed ----------------------------------------------------



  useEffect(() => {
    if (getStockCurrency() !== values?.currency && !securityCurrencyChanged && values?.stock) {
      // setSecurityCurrencyChanged(true)
      // setTimeout(() => {
      //   setSecurityCurrencyChanged(false);
      // }, 1000);
    }
    setBatchWac({
      batch_select_wac: []
    })
  }, [values?.stock])


  const getBatchSelect = useCallback(() => {
    let placeholder = t("Kaikki")
    if (values?.wac_date_gte && values?.wac_date_lte) {
      placeholder = t("Kaikki erät valitulta ajalta")
    }
    if (values?.wac_date_gte && !values?.wac_date_lte) {
      placeholder = ` ${t("Erät alkaen")} ${moment(values?.wac_date_gte).format('DD.MM.YYYY')} ` 
    }
    if (!values?.wac_date_gte && values?.wac_date_lte) {
      placeholder = ` ${t("Erät päättyen")} ${moment(values?.wac_date_lte).format('DD.MM.YYYY')} ` 
    }
    
    return <BatchSelect 
      name="batch_select_wac" 
      disabled={objectId?true:false} 
      label=" " 
      placeholder={placeholder} 
      multiple={true}  
      onChange={handleBatchMultiChange} 
      setFieldValue={handleBatchMultiChange} 
      value={batchWac?.batch_select_wac}  
      batchs={batchs} 
      batchRatio={batchRatio} 
      showPrivate={false} 
      showAll={false} 
      icon=""
      />
  }, [batchs, batchRatio, batchWac, investmentType, stockMarket, values?.stock, values.stock_private_obj, values?.wac_date_gte, values?.wac_date_lte])



  const allSecurity2OnChange = (value) => {
    console.log("allSecurity2OnChange", value)
    setInvestmentType(value?.related_model_type)   
    setStockMarket(value?.stock_market)
    setFundType(value?.type)
    setFieldValue("stock", {value: value?.value, label: value?.name, stockCurrency: value?.currency_label, stockMarket: value?.stock_market, id: value?.value, currency_label:value?.currency_label, ticker_symbol: value?.ticker_symbol})



  } 

  const get_initial_page = (values) => {
    //loop polygons and find smallest page, but if hover is true, then return that page
    let page = 1
    let smallest_page = 0
    let hover = false
    values.map(obj => {
      // if (obj.hover) {
      //   page = obj.page
      //   hover = true
      // }
      if (smallest_page === 0 && obj.page > 0) {
        smallest_page = obj.page -1
      }
      else if (obj.page <= smallest_page && obj.page > 0) {
        smallest_page = obj.page -1
      }
      
      
      // if (obj.page > page && !hover) {
      //   page = obj.page
      // }
    })
    
    console.log("page", page)
    return smallest_page 
  }


  const getImageWithPolygon = useCallback(() => {
    // console.log("trxFiles",trxFiles)
    //if trxFiles is not empty and file is pdf
    let polygons=[
      {polygon: values?.security_name_polygon, page: values?.security_name_page},
      {polygon: values?.security_ticker_symbol_polygon, page: values?.security_ticker_symbol_page},
      {polygon: values?.type_polygon, page: values?.transaction_type_page},
      {polygon: values?.date_polygon, page: values?.date_page},
      {polygon: values?.date_settlement_polygon, page: values?.date_settlement_page},
      {polygon: values?.broker_polygon, page: values?.broker_page},
      {polygon: values?.reference_code_polygon, page: values?.reference_number_page},
      {polygon: values?.quantity_polygon, page: values?.quantity_page},
      {polygon: values?.price_polygon, page: values?.price_page},
      {polygon: values?.total_amount_polygon, page: values?.total_amount_page},
      {polygon: values?.commission_polygon, page: values?.commission_page},
      {polygon: values?.commission_secondary_polygon, page: values?.commission_secondary_page},
      {polygon: values?.notes_polygon, page: values?.notes_page},
    ]
    
    // Define custom colors - commission and commission_secondary use same Mint Green color
    const customColors = [
      'rgba(253, 205, 63, 0.9)',   // 0: security_name - Yellow
      'rgba(22, 22, 64, 0.9)',     // 1: security_ticker_symbol - Dark Blue
      'rgba(255, 111, 97, 0.9)',   // 2: type - Coral
      'rgba(107, 91, 149, 0.9)',   // 3: date - Purple
      'rgba(136, 176, 75, 0.9)',   // 4: date_settlement - Olive Green
      'rgba(247, 202, 201, 0.9)',  // 5: broker - Light Pink
      'rgba(146, 168, 209, 0.9)',  // 6: reference_code - Light Blue
      'rgba(149, 82, 81, 0.9)',    // 7: quantity - Brownish Red
      'rgba(181, 101, 167, 0.9)',  // 8: price - Lavender
      'rgba(255, 160, 122, 0.9)',  // 9: total_amount - Light Salmon
      'rgba(72, 201, 176, 0.9)',   // 10: commission - Mint Green
      'rgba(72, 201, 176, 0.9)',   // 11: commission_secondary - Mint Green (SAME AS COMMISSION!)
      'rgba(255, 195, 0, 0.9)'     // 12: notes - Bright Yellow
    ];

    if (trxFiles.length > 0 && trxFiles[0].filename.includes(".pdf")) {
      return (
        <PdfWithPolygons 
          fileId={trxFiles[0].id}  
          fileName={trxFiles[0].filename}  
          polygons={polygons}
          colors={customColors}
          initialPage={get_initial_page(polygons)}
          setFieldValue={setFieldValue} /> 
      )
    }

    return(

      <ImageWithPolygons 
        fileId={trxFiles[0].id}  
        fileName={trxFiles[0].filename}  
        polygons={[
          values?.security_name_polygon,
          values?.security_ticker_symbol_polygon,
          values?.type_polygon,
          values?.date_polygon,
          values?.date_settlement_polygon,
          values?.broker_polygon,
          values?.reference_code_polygon,
          values?.quantity_polygon,
          values?.price_polygon,
          values?.total_amount_polygon,
          values?.commission_polygon,
          values?.commission_secondary_polygon,
          values?.notes_polygon,
        ]} 
        // polygons={[

        //   values?.type_polygon,

        // ]} 
        setFieldValue={setFieldValue} /> 

    )
  }, [trxFiles, values])

  
  return (
    <>

      {/*JSON.stringify(values)}
      {"---------------------"}
      {JSON.stringify(errors)*/}
      {/* {JSON.stringify(batchRatio)} */}

      {/* {JSON.stringify(values)}
      {JSON.stringify(portfolioSourceRate)} */}
    
    {openUpdateUp()}
    
    <div className="px-1">
     


      <Row className="mt-4 mb-1 border-bottom ">
        <Col xs={12} md={6} className="ml-auto pb-3">

          {objectId ? (
            <Typography variant="h2"  >{t("pre_transaction_edit_title", "Lisää kirjaus salkkuun")}</Typography>
          ) : (
            <div className="d-inline-flex">

            <Typography variant="h2">{t("pre_transaction_add_title", "Lisää kirjaus salkkuun")}: </Typography>
            <Typography variant="h2"  className="font-weight-light ml-1"> {portfolio?.name}</Typography>
            </div>
          )}
        </Col>
        <Col xs={12} md={6} className="ml-auto pb-3">
        {/* <PortfolioSelectStore icon="fas fa-suitcase" iconColor="text-secondary" disabled={true}/> */}
        </Col>
      </Row>
      <Row  className="py-3 ">

        <Col xs={12} lg={12} xl={3}  className="border-right px-1 pr-2 pt-0">
          {/* <InvestmentTypeSelect name="related_model_type1" onChange={handleInvestmentTypeChange} value={investmentType} disabled={objectId?true:false} showAll={false}/>
          {
            investmentType === 30 || investmentType === "30" ? (
            <Row className="mt-3">
              <Col>
                <InvestmentTypeSelectSub name="fund_type" onChange={handleFundChange} value={fundType} showPrivate={false} showAll={false} icon=""  disabled={objectId? true: false}/>
              </Col>
            </Row>
            ) : null
          }
          {
            investmentType === 10 || investmentType === "10" ? (
            <Row className="mt-3 ">
              <Col>
                <StockMarketSelect name="stock_market" onChange={handleStockMarketChange} value={stockMarket} disabled={objectId?true:false} showPrivate={false} showAll={false} icon=""/>
              </Col>
            </Row>
            ) : null
          }
          <Row>
            <Col className="mt-2">
             
            { getStockSelect() }

            { stockTickerSymbol ? (
              <div className="d-flex">
                <Typography variant="small" className="mr-auto pl-1">{t("Kaupankäyntitunnus")}: {stockTickerSymbol}</Typography>
                <Typography variant="small" style={{fontWeight: securityCurrencyChanged ? "normal" : "normal"}} className={securityCurrencyChanged && objectId == null ? "text-secondary pr-1" : "pr-1"}> {t('Valuutta')}: <span >{getStockCurrency()}</span></Typography>
              </div>
            ) : null }
            </Col>
          
          </Row> */}

          <Row>
            <Col className="mb-3">
              

              {values?.type ==3 && <AllSecuritySelect2  label={t("security", "Arvopaperi")} portfolio={portfolio?.id} onChange={allSecurity2OnChange} delisted={true} disabled={objectId?true:false}  value={values?.stock} sale={true} className={`${values?.security_name_polygon?.length > 0? "border rounded border-palet-yellow":"" }`} />}
              {values?.type !=3 && <AllSecuritySelect2  label={t("security", "Arvopaperi")} portfolio={portfolio?.id} onChange={allSecurity2OnChange} delisted={true} disabled={objectId?true:false} value={values?.stock} className={`${values?.security_name_polygon?.length > 0? "border rounded border-palet-yellow":"" }`}/>}

            { (stockTickerSymbol && object && false) ? (
              <div className="d-flex">
                <Typography variant="small"  className={`${values?.security_ticker_symbol_polygon?.length > 0? "border border-palet-dark-blue  mr-auto pl-1 ":"mr-auto pl-1 " }`}>{t("Kaupankäyntitunnus")}: {stockTickerSymbol}</Typography>
                <Typography variant="small" style={{fontWeight: securityCurrencyChanged ? "normal" : "normal"}} className={securityCurrencyChanged && objectId == null? "text-secondary pr-1" : "pr-1"}> {t('Valuutta')}: <span >{getStockCurrency()}</span></Typography>

              </div>
              
            ) : 
            <div className="d-flex">
              <Typography variant="small" className={`${values?.security_ticker_symbol_polygon?.length > 0? "border border-palet-dark-blue  mr-auto pl-1 ":"mr-auto pl-1 " }`}>{t("Kaupankäyntitunnus")}: {values?.stock?.ticker_symbol}{values?.stock?.stockMarket ? ":" + values?.stock?.stockMarket : ""}</Typography>
              <Typography variant="small" style={{fontWeight: securityCurrencyChanged ? "normal" : "normal"}} className={securityCurrencyChanged && objectId == null? "text-secondary pr-1" : "pr-1"}> {t('Valuutta')}: <span >{getStockCurrency()}</span></Typography>

            </div>
            }
            </Col>
          </Row>

            {
                values?.type == 3 && (
            <>

          {
              portfolio.sell_profit_calculation_method =="FIFO" && (
                  <>
              <Row className="mb-1">
              <Col  className="my-3">
              <div style={{position: 'absolute', zIndex: "0 !important"}}>
              <Checkbox 
              id="fifo"
              name="fifo_used"
              checked={values?.fifo_used}
              onChange={(e) => {setFieldValue("fifo_used",e.target.checked)}}
              value="agree_terms"
              required
              errorText={touched["agree_terms"] ? errors["agree_terms"] : ""}
              label={t("sale_fifo_used", "FIFO käytössä")}
              labelFirst={true}
              className="zIndexZero"
              />
              </div>
  
              </Col>
            </Row>
            <>
            {values?.fifo_used ? (
                <Row>
                  
                <Col className="mb-3 mt-2">
                  <Typography className="" variant="small">
                    {t("sale_fifo_info_text","Myynti eristä toteutetaan FIFO periaatteella, vanhimmat myydään ensin.")}
                  </Typography>
                </Col>
              </Row>
              ) : (
                  <Row className="mb-3">
                <Col sm={12} lg={12} className="d-flex align-items-center">
                  <label className="mb-1 pr-1 header">{t("pre_transaction_batch_select", "Hankintaerä")}</label>
                </Col>
                <Col className=" text-warning">
                  <BatchSelect  disabled={objectId?true:false} label=" "  {...getFormikInputProps("batch_select")} onChange={handleBatchChange} value={batch}  batchs={batchs} batchRatio={batchRatio} showPrivate={false} showAll={false} icon=""/>
                </Col>
              </Row>
              )}
            </>
      
            </>
            )
        }
        </>
        )
        }
        <Row> 
            <Col sm={12} lg={12} className="d-flex align-items-center">
            <label className="mb-1 pr-1 header">{t("pre_transaction_type", "Tyyppi")} *</label>
            </Col>
            <Col className="mb-2 mt-2">
            <div  className={`${values?.type_polygon?.length > 0? "border rounded border-palet-coral  ":"" }`}>

            <TransactionTypeSelect name="type" label=" " onChange={handleChange} value={values?.type} showAll={false}  />
            </div>

            </Col>
        </Row>
        


          {/* <Row className="row justify-content-end">
            <Col lg={8} md={12} className="mb-1 text-right">
              {stockMarket === "PRIVATE" ? (
                <Typography className="text-secondary" variant="small">
                {values.stock_private_obj === undefined || 
                  values.stock_private_obj === null || 
                  stockDatePrice ? null : t("Kurssin päätöshintaa Myyntipäivälle ei ole saatavilla ")}
                </Typography>

                ):(
                <Typography className="text-secondary" variant="small">
                {values.stock === undefined || 
                  values.stock === null || 
                  stockDatePrice ? null : t("Kurssin päätöshintaa myyntipäivälle ei ole saatavilla ")}
                </Typography>

              )}  
              </Col>
          </Row> */}
          
          <Row className="mb-3 mt-2">
            <Col sm={12} lg={12}  className="d-flex align-items-center">

              <label className="mb-1 pr-1 header">{t("pre_transaction_date_transaction", "Tapahtuma-päivä")} *</label>
            </Col>
            <Col className="mb-1">
              <DatePicker
                // className="form-control"
                selected={values?.date_transaction}
                name="date_transaction"
                onChange={(date) => {
                  setFieldValue("date_transaction", date)
                  setDateTransactionChanged(true)
                  
                }}
                showYearDropdown
                dateFormat="d.M.yyyy"
                placeholderText="15.1.2000"
                value={values?.date_transaction}
                disabled={objectId? true: false}
                // showTimeSelect
                customInput={<Input addonTypeClass="append" iconColor={"bg-light"} inputText={t(moment(values?.date_transaction).format("dddd"))}/>}
                
                className={`${values?.date_polygon?.length > 0? "border border-palet-purple form-control":"form-control" }`}
                // timeIntervals={1}
                // timeCaption="Time"
              />

              {/*
              <Input
                {...getFormikInputProps("date_transaction")}
                label={t("pre_transaction_date_transaction", "Myyntipäivä")}
                type="date"
              />
              */}

          </Col>
          </Row>
          <Row className="mb-3">
            <Col sm={12} lg={12} className="d-flex align-items-center">
              <label className="mb-1 pr-1 header">{t("Tapahtuma-aika")} *</label>
              <div> </div>
              <HelpText contentKey="transaction_edit_date_transaction_time" parentElementId="date_transaction_time" showButton={true}  />
            </Col>
            <Col className="mb-1">

                <DatePicker
                  className="form-control "
                  selected={values?.date_transaction}
                  name="date_transaction"
                  onChange={(date) => setFieldValue("date_transaction", date)}
                  showTimeSelect
                  showTimeSelectOnly
                  timeIntervals={1}
                  timeCaption="Time"
                  dateFormat="HH:mm"
                  placeholderText="12:00"
                  customInput={<Input addonTypeClass="append" iconColor={"bg-light"} inputText={t("klo")}/>}




                  // other props...
                />
            
            </Col>
          </Row>

          {/* <Row className="row justify-content-end">
            <Col lg={8} md={12} className="mb-3 d-flex">
            <Typography variant="small">{moment(values?.date_transaction).format("dddd")}</Typography>
            <Typography variant="small" className="ml-auto text-warning" >{t("syötä myös kellon aika")}</Typography>
            </Col>
          </Row> */}
          
          <Row className="mb-3">
            <Col sm={12} lg={12} className="d-flex align-items-center">
              <label className="mb-0 pr-1 header">{t("settlement_date", "Selvityspäivä")} *</label>
              <div> </div>
              <HelpText contentKey="transaction_edit_date_settlement" parentElementId="date_settlement_helptext" showButton={true}  className="mb-0"/>
            </Col>
            <Col className="mb-1">
              <DatePicker
                // className={`form-control b-0 calculated ${dateTransactionChanged ? "border-yellow" : ""}`}
                className={`${values?.date_settlement_polygon?.length > 0? "border border-palet-olive-green form-control":"form-control" }`}

                selected={values?.date_settlement}
                name="date_settlement"
                onChange={(date) => setFieldValue("date_settlement", date)}
                showYearDropdown
                dateFormat="d.M.yyyy"
                value={values?.date_settlement}
                customInput={<Input addonTypeClass="append" iconColor={"bg-light"} inputText={values?.date_settlement ? (moment(values?.date_settlement).format("dddd")):""}/>}
                disabled={objectId? true: false}

              />
              {/*
                <Input
                  {...getFormikInputProps("date_settlement")}
                  label={t("purchase_edit_date_settlement", "Selvityspäivä")}
                  type="date"
                />
              */}
              
            </Col>
          </Row>
          {/* <Row className="row justify-content-end">
            <Col lg={8} md={12} className="mb-3">
            <Typography variant="small">{moment(values?.date_settlement).format("dddd")}</Typography>
            </Col>
          </Row> */}

        <Row className="mt-2">
                    <Col sm={12} lg={12} className="d-flex align-items-center">
                      <label className="mb-0 pr-1 header">{t("broker", "Välittäjä")}</label>
                    </Col>
                    <Col className="mb-0">
                      <Input
                        {...getFormikInputProps("broker_name")}
                        placeholder={t("broker_placeholder", "Esim. Nordea")}

                        className={`${values?.broker_polygon?.length > 0? "border border-palet-light-pink":"" }`}

                        // icon="fas fa-user"
                      />
                    </Col>
          </Row>
          <Row className="mb-3 mt-3">
            <Col sm={12} lg={12} className="d-flex align-items-center">
              <label className="mb-0 pr-1 header">{t("reference_code", "Viite")}</label>
            </Col>
            <Col className="mb-0">
              <Input
                {...getFormikInputProps("reference_code")}
                // placeholder={t("reference_code", "Viite")}
                className={`${values?.reference_code_polygon?.length > 0? "border border-palet-light-blue":"" }`}
                
              />
            </Col>
          </Row>

          <Row className="mb-3">
            <Col sm={12} lg={12} className="d-flex align-items-center">
              <label className="mb-1 pr-1 header">{t("transaction_edit_comments", "Kommentit")}</label>
            </Col>
            <Col >
              <Input
                {...getFormikInputProps("notes")}
                className={`${values?.notes_polygon?.length > 0? "border border-palet-bright-yellow":"" }`}
                
                label=""
                // placeholder={t("transaction_edit_comments", "Kommentit")}
                type="textarea"
              />
            </Col>
          </Row>
          <Row className="row justify-content-end">
            <Col lg={12} md={12} className="mb-3 text-right">
              <Typography variant="small"  >{values?.notes && values?.notes.length || 0}/70</Typography>
            </Col>
          </Row>

        {
          portfolio.sell_profit_calculation_method == "WAC" && values?.type == 3 && (
            <>

              <Row className="mb-2">
                  <Col  className="my-3">
                  <div style={{position: 'absolute', zIndex: "0 !important"}}>
                  <Checkbox 
                  id="WAC"
                  name="wac_used"
                  checked={values?.wac_used}
                  onChange={(e) => {setFieldValue("wac_used",e.target.checked)}}
                  value="agree_terms"
                  required
                  errorText={touched["agree_terms"] ? errors["agree_terms"] : ""}
                  label={<>{t("sale_wac_used",'Rajaa huomioitavia eriä')}</>}
                  labelFirst={true}
                  className="zIndexZero"
                  />
                  </div>
      
                  </Col>
              </Row>
              {values?.wac_used ? (
                <>
              <Row className="mb-3">
                <Col sm={12} lg={12} className="d-flex align-items-center">
                  <label className="mb-1 pr-1 header">{t("Erät alkaen pvm")} </label>
                  <div> </div>
                  {/* <HelpText contentKey="transaction_edit_date_transaction_time" parentElementId="date_transaction_time" showButton={true}  /> */}
                </Col>
                <Col className="mb-1">
                  <DatePicker
                      className={`form-control b-0 calculated `}
                      // selected={values?.wac_date_gte}
                      selected={values?.wac_date_gte ? new Date(values?.wac_date_gte).setHours(12, 0, 0, 0) : null} // Set time to 12:00
                      //set some placeholder value
                      placeholderText={t("Ei rajausta")}
                      name="wac_date_gte"
                      onChange={(date) => setFieldValue("wac_date_gte", date)}
                      showYearDropdown
                      dateFormat="d.M.yyyy"
                      value={values?.wac_date_gte ? new Date(values?.wac_date_gte).setHours(12, 0, 0, 0) : null}
                      customInput={<Input addonTypeClass="append" iconColor={"bg-light"} inputText={values?.wac_date_gte ? (moment(values?.wac_date_gte).format("dddd")):""}/>}
                      disabled={objectId? true: false}

                  />
                </Col>
              </Row>
              <Row className="mb-3">
                <Col sm={12} lg={12} className="d-flex align-items-center">
                  <label className="mb-1 pr-1 header">{t("Erät päättyen pvm")} </label>
                  <div> </div>
                  {/* <HelpText contentKey="transaction_edit_date_transaction_time" parentElementId="date_transaction_time" showButton={true}  /> */}
                </Col>
                <Col className="mb-1">
                  <DatePicker
                      className={`form-control b-0 calculated`}
                      // selected={values?.wac_date_lte}
                      selected={values?.wac_date_lte ? new Date(values?.wac_date_lte).setHours(12, 0, 0, 0) : null} // Set time to 12:00
                      name="wac_date_lte"
                      onChange={(date) => setFieldValue("wac_date_lte", date)}
                      showYearDropdown
                      placeholderText={t("Ei rajausta")}
                      dateFormat="d.M.yyyy"
                      value={values?.wac_date_lte ? new Date(values?.wac_date_lte).setHours(12, 0, 0, 0) : null}
                      customInput={<Input addonTypeClass="append" iconColor={"bg-light"} inputText={values?.wac_date_lte ? (moment(values?.wac_date_lte).format("dddd")):""}/>}
                      disabled={objectId? true: false}

                  />
                </Col>
              </Row>
              <Row className="mb-3">
                <Col sm={12} lg={12} className="d-flex align-items-center">
                  <label className="mb-1 pr-1 header">{t("pre_transaction_batch_select_wac", "Valitut hankintaerät")}</label>
                </Col>
                <Col className=" text-warning">
                  {getBatchSelect()}
                  {/* <BatchSelect  disabled={objectId?true:false} label=" " multiple={true} {...getFormikInputProps("batch_select_wac")} onChange={handleBatchMultiChange} setFieldValue={handleBatchMultiChange} value={batch?.batch_select_wac}  batchs={batchs} batchRatio={batchRatio} showPrivate={false} showAll={false} icon=""/> */}
                </Col>
              </Row>
              </>
              ) : null
            }
          </>
          )
        }

          


          
          {/* <Row className="row justify-content-start mt-5">
            <Col lg={12} md={12} className="mb-1 text-left">
                <Typography className="text-red" variant="p">
                  {t("HUOM! Muista tehdä salkun sisällä samaa osaketta koskevat kirjaukset aina kronologisessa järjestyksessä.")}
                </Typography>
                {objectId &&  
                  <Typography className="text-red" variant="p">
                    {t("Mikäli tarve poistaa virheellinen kirjaus salkusta, tulee myös virheellistä kirjausta uudemmat samaa osaketta koskevat kirjaukset poistaa. Tämän jälkeen kaikki poistetut kirjaukset tulee luoda uudelleen.")}
                  </Typography>
                }
              </Col>
          </Row> */}



        </Col>
        <Col sm={12} lg={12} xl={3} className="px-2 pt-0">
          <Row>

            <Col className="mb-0">
               <label className="mb-1 pr-1 header-bold">{t("sale_information", "Maksutiedot")}</label>
            </Col>
          </Row>
          {/* <Row >
            <Col sm={12} lg={12} className="d-flex align-items-center">
              <label className="mb-0 pr-1 header">{t("purchase_order_edit_currency", "Valuutta")}</label>
            </Col>
            <Col className="mb-1">
              <CurrencySelect {...getFormikInputProps("currency")} label="" disabled={true}/>
              
              
            </Col>
          </Row>
          <Row className="row justify-content-end mb-3">
            {securityTargetRate && portfolioSourceRate && 
                <Col lg={8} md={12} >
                  <Typography variant="small">{t(`Valuuttakurssi`)}: {currencyDate ? currencyDate : (values?.currency_exchange_rate && values?.currency_exchange_rate !== 1 ? values?.currency_exchange_rate : t("Ei saatavilla"))} {securitySourceRateDate && <span className="text-gray">  ({securitySourceRateDate})</span>}</Typography>
                </Col>
            }
          </Row>
           */}
          {/* 
          <Row className="mb-3">
            <Col sm={12} lg={12} className="d-flex align-items-center">
              <label className="mb-1 pr-1 header">{t("transaction_edit_commission", "Palkkio")}</label>
            </Col>
            <Col className="mb-0">
              <CommissionSelect
                {...getFormikInputProps("commission")}
                allOption={false}
                label=""
                disabled= {objectId? true : false}
              />
            </Col>
          </Row> */}
          
          <Row className="mb-2">
          
            <Col sm={12} lg={12} className="d-flex align-items-center">
              <label className="mb-1 pr-1 header">{t("transaction_edit_quantity", "Kappalemäärä")} *</label>
            </Col>
            <Col sm={12} lg={12} >
                {/* {JSON.stringify(values?.quantity_hover)} */}

                <Input
                  {...getFormikInputProps("quantity")}
                  onMouseEnter={() => setFieldValue("quantity_hover", true)}
                  onMouseLeave={() => setFieldValue("quantity_hover", false)}
                  label=""
                  type="number"
                  min={0}
                  addonTypeClass="append"
                  iconColor={"bg-lighter"}
                  inputText={t("kpl")}
                  step={investmentType == 10 || investmentType == 20?"1":"0.01" }
                  onWheel={(e) => e.target.blur()}
                  placeholder={t("")}
                  disabled= {objectId? true : false}
                  
                  // className={`calculated ${calculatePriceTotalClicked || calculatePriceClicked ? "border-yellow" : values?.quantity_polygon?.length > 0? "border border-palet-brown-ishred":"" }`}
                  // className={`${values?.quantity_polygon?.length > 0? " border custom-border-strong  border-palet-brown-ishred " values?.quantity_hover ? "custom-border-strong" :"" }`}
                  className={`${values?.quantity_polygon?.length > 0 ? "border border-palet-brown-ishred" : ""} ${
                    values?.quantity_hover ? "custom-border-strong" : ""
                  }`}
                />


            </Col>
            {values.batch_select && !values.fifo_used &&(
              <Col sm={12} lg={12} className="d-flex align-items-center">
              <Typography variant="small">{getBatchObj(values.batch_select) } {t("pre_transaction_batch_balance", " saatavilla")}</Typography>
              </Col>
            )}
            {(values.fifo_used || portfolio.sell_profit_calculation_method=="WAC") && values.stock && values?.type ==3 && (
              <Col sm={12} lg={12} className="d-flex align-items-center">
              <Typography variant="small">{roundScaleDecimals(getBatchesBalance(), 6)} {t("pre_transaction_batch_balance"," saatavilla")}</Typography>
              
              </Col>
            )}
            
          </Row>
          <Row className="mb-1">
            <Col sm={12} lg={12} className="d-flex align-items-center">
              <label className="mb-1 pr-1 header">{t("transaction_edit_price", "Kappalehinta")} *</label>
            </Col>
            <Col sm={12} lg={12} >
              <Input
                {...getFormikInputProps("price")}
                label=""
                type="number"
                step="0.01"
                min={0}
                onWheel={(e) => e.target.blur()}
                placeholder={t("")}
                addonTypeClass="append"
                iconColor={"bg-lighter"}
                // inputText={values?.currency}
                inputText={    
                  <>
                  {
                      values?.currency != values?.original_price_currency
                      ?                  <Button className="text-white font-weight-light rounded-circle custom-xs-button-input  b-0  d-flex align-items-center"  style={{position:"relative", zIndex: 0}}  variant="lighter" disabled={true} >
                      <i className="fas fa-exchange-alt text-primary bg-gray-400 fa-xl"  />
                 
                      <Typography variant="p" className="text-dark">     {values?.currency}</Typography>
                      </Button>
                      :  <Typography variant="p" className="text-dark">     {values?.currency}</Typography>


                  }
                  </>
}
                // className={`calculated ${calculatePriceTotalClicked ? "border-yellow" : ""}`}
                className={`${values?.price_polygon?.length > 0? "border border-palet-lavender":"" }`}

                disabled= {objectId? true : false}

              />

            </Col>
            <Col className="text-left  mt-sm-2  mt-md-0">
              <Button variant="default" size="sm" className="mt-2" disabled={objectId? true: false} onClick={() => handleCalculatePrice()} >
                <Typography variant="p" className="text-dark">{ t("transaction_edit_calculate_price", "Laske kpl hinta") }</Typography>
                
              </Button>
            </Col>
          </Row>
          {
            values?.original_price &&
          <Row className="row justify-content-end">
            <Col lg={12} md={12} className="mb-1">
              <div className="d-flex ">
                <Typography variant="small" className="ml-2"><span className="text-gray">{values?.original_price}{t(" valuutta")}: {values?.original_price_currency}</span></Typography>
              </div>

            </Col>
          </Row>
          }   
          
          {/* {(values?.quantity && values?.stock && !objectId) ?

              <Row className="row justify-content-end">
                <Col lg={12} md={12} className="mb-0">
                  <Typography variant="small">
                    {t("Tapahtumapäivän päätöshinta")}:  {
                          stockDatePriceLoading ? 
                            <Spinner animation="border" size="xs" className="spinner-height-15"/> 
                            : stockDatePrice ? 
                              <><span >{roundScaleDecimals(stockDatePrice / currencyDate,2)} {t(values?.currency)}</span> {getStockCurrency() != values?.currency ? <span className="text-gray">({stockDatePrice} {getStockCurrency() })</span> : null}</>
                              : t("Ei saatavilla")}
                    </Typography>
                </Col>
              </Row>
              : null
          } */}

          
          <Row className="mt-2 mb-1">
            <Col sm={12} lg={12} className="d-flex align-items-center">
              <label className="mb-1 pr-1 header">{t("transaction_edit_price_total", "Erän hinta")} *</label>
            </Col>
            <Col sm={12} lg={12} className="mb-0">
              <Input
                {...getFormikInputProps("price_total")}
                label=""
                type="number"
                step="0.01"
                min={0}
                // style={{ backgroundColor: "green", color: "white" }}
                onWheel={(e) => e.target.blur()}
                placeholder={t("")}
                // className={`calculated ${calculatePriceClicked ? "border-yellow" : ""}`}
                className={`${values?.total_amount_polygon?.length > 0? "border border-palet-light-salmon":"" }`}

                disabled= {objectId? true : false}
                addonTypeClass="append"
                iconColor={"bg-lighter"}
                // inputText={values?.currency}
                inputText={     
                <>
                {values?.currency != values?.original_price_currency
                ?
                <Button className="text-white font-weight-light rounded-circle custom-xs-button-input  b-0  d-flex align-items-center"  style={{position:"relative", zIndex: 0}}  variant="lighter" disabled={true} >
                <i className="fas fa-exchange-alt text-primary bg-gray-400 fa-xl"  />
           
                <Typography variant="p" className="text-dark">     {values?.currency}</Typography>
                </Button>
                :  <Typography variant="p" className="text-dark">     {values?.currency}</Typography>
                
                } 
                </>
                }
              />
            </Col>
            <Col className="text-left  mt-sm-2  mt-md-0">
              <Button name="calculate_price_total" variant="default" size="sm"  className="mt-2" disabled={objectId? true: false} onClick={() => handleCalculatePriceTotal()}>
                
                <Typography variant="p" className="text-dark">{ t("Laske eränhinta") }</Typography>
              </Button>
            </Col>
          </Row>
          {values?.original_price_total && 
          <Row className="row justify-content-end">
            <Col lg={12} md={12} className="mb-2">
              <div className="d-flex ">
                <Typography variant="small" className="ml-2"><span className="text-gray">{values?.original_price_total}{t(" valuutta")}: {values?.original_price_total_currency}</span></Typography>
              </div>

            </Col>
          </Row>
          }
          
          <Row className="mb-1">
            <Col sm={12} lg={12} className="d-flex align-items-center">
              <label className="mb-1 pr-1 header">{t("transaction_commission_total", "Kulut")}</label>
            </Col>
            <Col sm={12} lg={12} >
              <Input
                {...getFormikInputProps("commission_total")}
                className={`${values?.commission_polygon?.length > 0? "border border-palet-mint-green":"" }`}
                
                label=""
                type="number"
                step="0.01"
                min={0}
                // style={{ backgroundColor: "red", color: "white" }}
                onWheel={(e) => e.target.blur()}
                placeholder={t("")}
                disabled= {objectId? true : false}
                addonTypeClass="append"
                iconColor={"bg-lighter"}
                // inputText={values?.currency}
                inputText={   
                  <>
                  {
                    values?.currency != values?.original_commission_total_currency 
                    ?
                    <Button className="text-white font-weight-light rounded-circle custom-xs-button-input  b-0  d-flex align-items-center"  style={{position:"relative", zIndex: 0}}  variant="lighter" disabled={true} >
                    <i className="fas fa-exchange-alt text-primary bg-gray-400 fa-xl"  />
               
                    <Typography variant="p" className="text-dark">     {values?.currency}</Typography>
                    </Button>
                    : <Typography variant="p" className="text-dark">     {values?.currency}</Typography>

                  }
                  </>
                  
}
              />
            </Col>
          </Row>
          {values?.original_commission_total && 
          <Row className="row justify-content-end">
            <Col lg={12} md={12} className="mb-2">
              <div className="d-flex ">
                <Typography variant="small" className="ml-2">
                  <span className="text-gray">
                    {values?.commission_secondary && parseFloat(values?.commission_secondary) > 0
                      ? `${(parseFloat(values?.original_commission_total || 0) - parseFloat(values?.commission_secondary)).toFixed(2)} + ${parseFloat(values?.commission_secondary).toFixed(2)} = ${values?.original_commission_total}`
                      : values?.original_commission_total
                    }
                    {t(" valuutta")}: {values?.original_commission_total_currency}
                  </span>
                </Typography>
              </div>
            </Col>
          </Row>
        }
  
          <Row className="row justify-content-end">
             <Col sm={12} lg={12} className="d-flex align-items-center">
                <label className="mb-1 pr-1 header">{t("transaction_edit_value_total", "Hinta yhteensä")}</label>
            </Col>
            <Col lg={12} md={12} className="mb-2">
             <Typography variant="small" className={totalValue > 0?"text-dark":totalValue < 0?"text-dark": null}> {totalValue ? thousandFormat(totalValue) : 0.0} ({values?.currency})</Typography>
            </Col>
          </Row>
          

          { values.currency != getStockCurrency() && values?.stock != null  ? (
          <Row className="row justify-content-end">
            <Col lg={12} md={12} className="mb-2">
              <div className="d-flex ">
                <Typography variant="small" className={totalValue > 0?"text-dark":totalValue < 0?"text-dark": null}> {totalValueEur ? thousandFormat(totalValueEur) : 0.0} {values?.original_price_currency}</Typography>
                <Typography variant="small" className="ml-2"><span className="text-gray">{t("transaction_edit_rate",`Kurssi`)}: {currencyDate ? currencyDate : (values?.currency_exchange_rate && values?.currency_exchange_rate !== 1 ? values?.currency_exchange_rate : t("Ei saatavilla"))} {securitySourceRateDate && <span className="text-gray">  ({securitySourceRateDate})</span>}</span></Typography>
              </div>

            </Col>
          </Row>
          ) : null}


   
          {account && account?.license?.name !== "Lite" && (
            <>
            <Row className="mb-3">
            <Col sm={12} lg={12} className="d-flex ">
              <label className="mb-0 mt-2 pr-1 header">{t("attachment_file", "Liite")}</label>
            </Col>
            <Col className="mb-0">
              <UploadFile apiUrl="https://your-server.com/upload" setFiles={setFiles} files={files} padding={15} />
            </Col>
            
          </Row>
            <Row className="mb-3">
              <Col sm={12} lg={12} className="d-flex ">
              </Col>
              <Col className="mb-0">
                <TransactionsFileHandling setFiles={setTrxFiles} files={trxFiles} transaction={values} setFieldValue={setFieldValue} values={values}/>
                {/* {JSON.stringify(values?.connect_files)} */}
              </Col>
              
            </Row>
            </>
            )}
            <Row className="mt-auto">
                        <Col sm={12} lg={12} className="d-flex align-items-center">
                        <label className="mb-1 pr-1 header">{t("transaction_edit_comments", "AI:lle ohjeita")}</label>
                        </Col>
                        <Col >
                        <Input
                            {...getFormikInputProps("ai_comments")}
                            label=""
                            // placeholder={t("transaction_edit_comments", "Kommentit")}
                            type="textarea"
                        />
            </Col>
          </Row>



          <Typography  variant="small" className="mt-2 text-gray">
            {t("purchase_edit_required","* Tähdellä merkityt ovat pakollisia")}
          </Typography>
        </Col>
        <Col className="px-4 pt-0">
            {/* {JSON.stringify(trxFiles)} */}
            {
              trxFiles?.length > 0 &&
              <div>

                {getImageWithPolygon()}
              </div>
            //  <ImageWithPolygons fileId={trxFiles[0].id} filename={trxFiles[0].filename} polygons={values?.polygons} setFieldValue={setFieldValue} /> 
            }
        </Col>


      </Row>
      
      <Row>
        <Col>{/*JSON.stringify(values)*/}</Col>
      </Row>
      <Row className="  bg-lighter pt-3  rounded-bottom">
        <Col className="mb-3">
          <Button name='saleEdit_cancel' onClick={handleCancel} variant="secondary" className="sk-modal-dismiss">{t("Sulje")}</Button>
        </Col>
  
        <Col className="mb-3 text-center">
          <Button name='transactionEdit_pass ' onClick={handlePass} variant="light">{t("Ohita")}</Button>
        </Col>
    
        <Col className="mb-3 text-right">
          { !preSetValues?.state_delivery && (
            <Button name='saleEdit_submit' variant="primary" disabled={isSubmitting} onClick={onSubmit}>
              { t("Kirjaa ja tallenna") }
            </Button>
          )}
          
          { Boolean(errors["general"]) && <Typography className="text-danger">{errors["general"]}</Typography> }
        </Col>
      </Row>
      </div>
    </>
  );
}

const PurchaseEditFormik = withFormik({
    enableReinitialize: true,
    validateOnMount: true,
    mapPropsToValues: props => {
      const { preSetValues } = props;
      if ( preSetValues) {
        return preSetValues;
      } else {
        return {
          ...defaultValues
        }
      }
    },
    validationSchema: props => {  
      const {t, stockMarket, investmentType, objectId,object, maxSaldo, transactionType} = props;

      const required = t("Kenttä on pakollinen");
      if (stockMarket === "PRIVATE") {
        return Yup.object().shape({
          //checht that stock are object with id
          stock_private_obj: Yup.object().shape({
            id: Yup.number().nullable().required(required),
          }).nullable().required(required),
          quantity: Yup.number().required(required).nullable(),
          price : Yup.string().required(required).nullable(),
        });
      }
      else {

        return Yup.object().shape({
          //checht that stock are object with id
          stock: Yup.object().shape({
            id: Yup.number().nullable().required(required),
          }).nullable().required(required),
          // quantity: investmentType <=20?Yup.number().integer().min(0, t('Arvon tulee olla vähintään 0')).required(t('Arvo on pakollinen')): Yup.number().min(0.0000000000000, t('Arvon tulee olla enemmän kuin 0')).required(required).nullable(),
          quantity: investmentType <=20?Yup.number().integer().min(0, t('Arvon tulee olla vähintään 0')).required(t('Arvo on pakollinen')).test(
            "quantity-check",
            t("Määrä ei voi ylittää saldoa"),
            function(value) {
              const batchesBalance = maxSaldo;
              if (objectId) {
                return true;
              }
              if (transactionType == 3){
                  return value <= batchesBalance;
              }
                return true;
            }
          ): Yup.number().min(0.0000000000000, t('Arvon tulee olla enemmän kuin 0')).required(required).test(
            "quantity-check",
            t("Määrä ei voi ylittää saldoa"),
            function(value) {
              const batchesBalance = maxSaldo;
              if (objectId) {
                return true;
              }
              if (transactionType == 3){
                return value <= batchesBalance;
            }
              return true;
            }
          ).nullable(),
          price: Yup.string().min(0.000000000000, t('Arvon tulee olla enemmän kuin 0')).required(required).nullable(),
          
          // price: Yup.string().test(
          //   "not-0",
          //   t("Value cannot be '0'"),
          //   (value) => value !== "0"
          // ),
          price_total: Yup.number().min(0.0000000000000, t('Arvon tulee olla enemmän kuin 0')).required(required).nullable(),
          date_transaction: Yup.date().required(required).nullable(),
          // value_total: Yup.number().notOneOf([0], t("Arvo ei voi olla 0")).required(required).nullable()
        });
      }
    },
    handleSubmit: (values, { setSubmitting, setErrors, props }) => {
      const {t, currencyDate, portfolio, investmentType, setFilters, stockMarket, totalValue, objectId, object, batchWac, handleFileUpload, files, handleResolve} = props;

      let data = {}

      // Ensure type is converted to integer
      let type = values?.type ? parseInt(values?.type, 10) : values?.type

      let positive_or_negative = type == 2 ? - 1 : 1

      let price_total = values?.price_total && parseFloat(values?.price_total.toString().replace(",",".")) * positive_or_negative
      let price = values?.price && parseFloat(values?.price.toString().replace(",",".")) * positive_or_negative
      let value_total = totalValue && parseFloat(totalValue.toString().replace(",",".")) * positive_or_negative
      let commission_total = values?.commission_total ? -Math.abs(parseFloat(values?.commission_total.toString().replace(",","."))) : 0
      
      // Batch balance only for purchase (type 2), not for sale (type 3)
      let original_batch_balance = type == 2 ? values?.quantity &&  roundScaleDecimals(parseFloat(values?.quantity.toString().replace(",",".")),6) : undefined
      let batch_balance = type == 2 ? values?.quantity && roundScaleDecimals(parseFloat(values?.quantity.toString().replace(",",".")),6) : undefined
    
      let connect_files =  []

      connect_files.push({value: object.file.id, label: object.file.filename})
      if (values?.connect_files){
        connect_files = connect_files.concat(values?.connect_files)
      }
      

 
        data = {
            ...values,
            commission_total:commission_total, 
            currency_exchange_rate: values?.currency_exchange_rate ? roundScaleDecimals(parseFloat(values?.currency_exchange_rate), 6) : 1,
            currency_label: values?.currency,
            portfolio: portfolio?.id,
            price:price,
            price_total: price_total,

            // stock: values?.stock_private_obj?.id,
            stock: values?.stock?.id,
            type:type,
            date_settlement: values?.date_settlement? moment(values?.date_settlement).format() : undefined,
            date_transaction: values?.date_transaction ? moment(values?.date_transaction).format() : undefined,
            stock_market: stockMarket,
            related_model_id: values?.stock?.id,
            related_model_type: investmentType,
            fifo_used: values?.fifo_used? values?.fifo_used : false,
            // state: values?.state?.key,
            value_total: value_total,
            reference_code: values?.reference_code,
            // wac_date_lte: values?.wac_date_lte ? moment(values?.wac_date_lte).format() : undefined,
            // wac_date_gte: values?.wac_date_gte ? moment(values?.wac_date_gte).format() : undefined,
            wac_date_lte: values?.wac_date_lte ? moment(values?.wac_date_lte).set({hour: 12, minute: 0, second: 0, millisecond: 0}).format() : undefined,
            wac_date_gte: values?.wac_date_gte ? moment(values?.wac_date_gte).set({hour: 12, minute: 0, second: 0, millisecond: 0}).format() : undefined,
            wac_ids: batchWac && batchWac?.batch_select_wac.map(item => item.id),
            original_batch_balance: original_batch_balance,
            batch_balance: batch_balance,
            connect_files: connect_files,

            
            //change wac_date_lte clock time to 12:00

        };

      if (investmentType != "10"){
        data.ticker_symbol = null
        data.stock_market = null
      }
      if (values?.id) {
        if (stockMarket === "PRIVATE") {
          setSubmitting(true)
          httpUpdatePrivateStockTransaction (values?.id, data).then(res => {
            props.notify({ title:t("Kirjaus"), message:t("Päivitetty onnistuneesti")})

            handleResolve()
          }, error => {
            props.notify({ title:t("Kirjaus"), message:t("Päivitetys epäonnistui")})

            console.log("httpCreateStockTransaction error", error);
            if (error?.status === 400) {
              setErrors(error?.data)
            }
            else {
              setErrors({
                general: t("Tuntematon virhe. Yritä myöhemmin uudelleen tai ota yhteys tukeen.")
              })
            }
            
          }).finally(() => {
            setSubmitting(false)
          })
        }
        else {
          setSubmitting(true)
          //remove stock_market from data
          delete data.original_batch_balance
          delete data.batch_balance
          delete data.value_total
          delete data.stock_market
          delete data.price_total
          delete data.commission_total
          delete data.value_total
          delete data.price
          delete data.stock_market
          delete data.fifo_used
          delete data.wac_date_lte
          delete data.wac_date_gte
          delete data.wac_ids
          delete data.currency_exchange_rate
          delete data.currency_label
          delete data.date_settlement
          delete data.date_transaction
          httpUpdateTransaction(values?.id,data).then(res => {

            if(res?.data?.id){
              handleFileUpload([res?.data?.id], files)
            }
            props.notify({ title:t("Kirjaus"), message:t("Päivitetty onnistuneesti")})
            if (investmentType == "10"){
                setFilters(s => ({
                    ...s,
                    // stock_market: stockMarket,
                    // related_model_type: investmentType,
                    stock_market: null,
                    related_model_type: null,
                  }))
            }
            else {
                setFilters(s => ({

                    ...s,
                    // stock_market: null,
                    // related_model_type: investmentType,
                    stock_market: null,
                    related_model_type: null,

                  }))
            }
            handleResolve()
          }, error => {
            props.notify({ title:t("Kirjaus"), message:t("Päivitetys epäonnistui")})
            console.log("httpCreateStockTransaction error", error);
            if (error?.status === 400) {
              setErrors(error?.data)
            }
            else {
              setErrors({
                general: t("Tuntematon virhe. Yritä myöhemmin uudelleen tai ota yhteys tukeen.")
              })
            }
            
          }).finally(() => {
            setSubmitting(false)
          })
        }
      }
      else {
        if (stockMarket === "PRIVATE") {
          setSubmitting(true)
          httpCreatePrivateStockTransaction(data).then(res => {
            props.notify({ title:t("Kirjaus"), message:t("Lisätty onnistuneesti")})

            handleResolve()
          }, error => {
            console.log("httpCreateStockTransaction error", error);
            if (error?.status === 400) {
              setErrors(error?.data)
            }
            else {
              setErrors({
                general: t("Tuntematon virhe. Yritä myöhemmin uudelleen tai ota yhteys tukeen.")
              })
            }
            
          }).finally(() => {
            setSubmitting(false)
          })
  
        }
        else {
          // console.log(data.date_transaction)
          setSubmitting(true)
          // const oldDate = new Date(data.date_transaction);
          // const newDate = new Date(oldDate.getFullYear(), oldDate.getMonth(), oldDate.getDate(), 12, 0, 0);
          // const formattedDate = newDate.toISOString().split('T')[0] +" 12:00:00Z";;
          // data.date_transaction = formattedDate;

          httpCreateTransaction(data).then(res => {
            if(res?.data?.id){
              handleFileUpload([res?.data?.id], files)
            }
            props.notify({ title:t("Kirjaus"), message:t("Lisätty onnistuneesti")})


            const pre_update_data ={
                id: object?.id,
                portfolio: object?.portfolio,
                processed: true,
            }

            httpUpdatePreTransaction(pre_update_data ).then(res => {
                console.log("httpUpdatePreTransaction", res)
                
                // AI messages (non-blocking, ei tarvitse odottaa)
                const ai_data = {
                    name: "Correction",
                    type: 2,
                    role: "user",
                    schema_model: "Transaction",
                    content: values?.ai_comments,
                    portfolio: portfolio?.id,
                }

                httpCreateFileAiMessages(ai_data).then(res => {
                    console.log("httpCreateFileAiMessages", res)
                }, error => {
                    console.log("httpCreateFileAiMessages error", error)
                })
                
                // Resolve only after PreTransaction is updated
                handleResolve()
            }, error => {
                console.log("httpUpdatePreTransaction error", error)
                // Resolve even on error to close modal
            }
            )
          }, error => {
            console.log("httpCreateStockTransaction error", error);
            if (error?.status === 400) {
              // setErrors(error?.data)
              console.log("error?.data", error?.data)
              if (error?.data?.message) {
                props.notify({ title:t("Kirjaus"), message:error?.data?.message, type:'danger', autoDismiss:9})
              }
              else if (error?.data?.general) {
                props.notify({ title:t("Kirjaus"), message:error?.data?.general, type:'danger' , autoDismiss:9})
              }
              else {
                setErrors(error?.data)
              }
            }
            else {
              setErrors({
                general: t("Tuntematon virhe. Yritä myöhemmin uudelleen tai ota yhteys tukeen.")
              })
            }
            
          }).finally(() => {
            setSubmitting(false)
          })
        }

      }

    },
    displayName: "BasicForm"
  
})(PurchaseEdit)
    
    
const SaleEditView = ({history, object,objectId,defaultStockMarket,defaultInvestmentType="10", ticker_symbol,transaction_count, setFilters, modalOpen, ...rest}) => {
  // API requests here
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [preSetValues, setPreSetValues] = useState(defaultValues);
  const { notify } = useNotification(); // import { useNotification } from "stories/components/Notification"
  const [totalValue, setTotalValue] = useState(0);
  const [totalValueEur, setTotalValueEur] = useState(0);
  const [stockMarket, setStockMarket] = useState(defaultStockMarket? defaultStockMarket : "XHEL");
  const [investmentType, setInvestmentType] = useState(defaultInvestmentType? defaultInvestmentType : "10");

  const [currencyDate, setCurrencyDate] = useState(1.0);
  const [currentStock, setCurrentStock] = useState(null);
  const [batchs, setBatchs] = useState([]);
  const [batchRatio, setBatchRatio] = useState(1);
  const [securityTargetRate, setSecurityTargetRate] = useState(1.0);
  const [portfolioSourceRate, setPortfolioSourceRate] = useState(1.0);
  const [securitySourceRateDate, setSecuritySourceRateDate] = useState(null);
  const [maxSaldo, setMaxSaldo] = useState(0);

  const [transactionType, setTransactionType] = useState(object?.type);
  
  // Store
  const options = useStoreState((state) => state.options?.options);
  const addOption = useStoreActions((actions) => actions.options.addOption);
  const stocks = useStoreState((state) => state.stocks?.objects);
  const stocksLoading = useStoreState((state) => state.stocks?.loading);
  const portfolios = useStoreState((state) => state.portfolio?.portfolios);
  const activePortfolio = useStoreState((state) => state.portfolio?.portfolio);
  // Use portfolio from object data, fallback to active portfolio
  const portfolio = object?.portfolio ? portfolios?.find(p => p.id === object.portfolio) || activePortfolio : activePortfolio;
  const getBasicDataObjects = useStoreActions((actions) => actions.stocks.getObjects);
  const getPrivateBasicDataObjects = useStoreActions((actions) => actions.privateStocks.getObjects);
  const privateStocks = useStoreState((state) => state.privateStocks?.objects);
  const [fundType, setFundType] = useState("private_stock");
  const [batchWac, setBatchWac] = useState({
    batch_select_wac: []
  })
  const [files, setFiles] = useState([]);
  const [trxFiles, setTrxFiles] = useState([]);
  
  const account = useStoreState((state) => state.account?.account);

  
  useEffect(() => {
    if (portfolio) {
      setPreSetValues(s => ({
        ...s,
        currency: portfolio?.currency_label
      }))
    }
  }, [portfolio])

  const handleFileUpload = (transactions) => {
    if (!files?.length) return
    const formData = new FormData();
    files.forEach(file => formData.append('file', file))
    // formData.append('files', files);
    formData.append('account', account?.id);
    formData.append('transactions', transactions)
  
    formData.append('portfolio', portfolio.id);
    // setLoadingSendExcel(true)
    httpUploadFiles(formData).then(res => {
      if (res?.data){
  
        console.log(res?.data)
      }
      setFiles([])
  
      // setLoadingSendExcel(false)
  
    }, error => {
      // setErrorText("Tapahtumien tuonti epäonnistui")
      if(error?.data?.message) {
        // setErrorMessage(t(error?.data?.message))
      }
      if(error?.data?.general) {
        //replace : with . to avoid rendering issues
        const general = error?.data?.general?.toString()
        const formattedError = general.replace(/:/g, '.')
        // setErrorMessage(t(formattedError))
      }
  
    }).finally(() => {
      // setLoadingSendExcel(false)
  
      // setLoadingImport(false)
    })
  
  
  };

  const findObject = useCallback ((id) => {
    // const filteredObjects = stocks && stocks.filter(o => o.id === id)
    // if (filteredObjects && filteredObjects.length > 0) {
    //   return filteredObjects[0]
    // }
    // return null

    let filteredObjects = null
    if (stockMarket === "PRIVATE") {
      filteredObjects = privateStocks && privateStocks.filter(o => o.id === id)
    }
    else {
      filteredObjects = stocks && stocks.filter(o => o.id === id)
    }
    if (filteredObjects && filteredObjects.length > 0) {
      return filteredObjects[0]
    }
    return null
  }, [stocks, stocksLoading])


  
  const getObject = (id) => {
    setLoading(true)

    if (stockMarket === "PRIVATE") {
      httpGetPrivateStockTransaction(id).then(res => {
        setStockMarket(res?.data?.stock_market_label)
  
        getPrivateBasicDataObjects({stock_market:res?.data?.stock_market_label})
        setPreSetValues({
          ...defaultValues,
          ...res.data,
          date_transaction: res?.data?.date_transaction ? moment(res?.data?.date_transaction).toDate() : new Date(),
          date_settlement: res?.data?.date_settlement ? moment(res?.data?.date_settlement).toDate() : new Date(),
          wac_date_gte: res?.data?.wac_date_gte ? moment(res?.data?.wac_date_gte).toDate() : null,
          wac_date_lte: res?.data?.wac_date_lte ? moment(res?.data?.wac_date_lte).toDate() : null,
          stock_private_obj:{id: res?.data?.stock, value:res?.data?.stock, label: findObject(res?.data?.stock)?.name},
  
          // price: round(res?.data?.price, 2) * -1,
          // value_total : round(res?.data?.value_total, 2) ,
          // price_total : round(res?.data?.price_total, 2) ,
          // commission_total : round(res?.data?.commission_total, 2) ,
          price: roundScaleDecimals(res?.data?.price, 6) ,
          value_total : roundScaleDecimals(res?.data?.value_total, 6) ,
          price_total : roundScaleDecimals(res?.data?.price_total, 6) ,
          commission_total : roundScaleDecimals(res?.data?.commission_total, 6) ,
          
        });
      
      }).finally(response => {
        setLoading(false);
      })
    }
    else{
      httpGetTransaction(id).then(res => {
        setStockMarket(res?.data?.stock_market)

        setTrxFiles(res?.data?.files)
  
        
        getBasicDataObjects({stock_market:res?.data?.stock_market, related_model_type: investmentType, show_hidden: true})

        setPreSetValues({
          ...defaultValues,
          ...res.data,
          date_transaction: res?.data?.date_transaction ? moment(res?.data?.date_transaction).toDate() : new Date(),
          date_settlement: res?.data?.date_settlement ? moment(res?.data?.date_settlement).toDate() : new Date(),
          wac_date_gte: res?.data?.wac_date_gte ? moment(res?.data?.wac_date_gte).toDate() : null,
          wac_date_lte: res?.data?.wac_date_lte ? moment(res?.data?.wac_date_lte).toDate() : null,
          // stock:{id: res?.data?.related_model_id, value:res?.data?.related_model_id, label: findObject(res?.data?.related_model_id)?.name},
          stock:{id: res?.data?.related_model_id, value:res?.data?.related_model_id, label: res?.data?.related_model?.name, ticker_symbol: res?.data?.ticker_symbol, stock_market: res?.data?.related_model?.stock_market},

  
          price: roundScaleDecimals(res?.data?.price, 6) ,
          value_total : roundScaleDecimals(res?.data?.value_total, 6) ,
          price_total : roundScaleDecimals(res?.data?.price_total, 6) ,
          commission_total : roundScaleDecimals(res?.data?.commission_total, 6) ,
          ticker_symbol : ticker_symbol,
          
          

        });
      
      }).finally(response => {
        setLoading(false);
      })
    }


    
  }
  
  useEffect(() => {
    if (objectId && parseInt(objectId) > -1) {
      getObject(objectId)
    }
    if (object) {
        console.log(object)
        setInvestmentType(object?.related_model_type) // Set investmentType state from object
        setStockMarket(object?.stock_market) // Set stockMarket state from object
        getBasicDataObjects({related_model_type: object?.related_model_type, id:object?.related_model_id, show_hidden: true})
        setTrxFiles([object.file])
        
        // Apply currency conversion using exchange rate or default to 1
        const exchangeRate = object?.currency_exchange_rate || 1.0;
        const exchangeRateDirection = object?.currency_exchange_rate_direction || 'multiply';
        
        // Apply conversion based on direction
        const applyExchangeRate = (value) => {
          if (!value) return value;
          if (exchangeRateDirection === 'divide') {
            return roundScaleDecimals(value / exchangeRate, 4);
          }
          return roundScaleDecimals(value * exchangeRate, 4);
        };
        
        const convertedPrice = applyExchangeRate(object?.price);

        // Fix duplicated cost: backend sometimes sets the same brokerage fee both as main commission
        // and as commission_secondary (e.g. Nordea "Välityspalkkio" 208.52 SEK twice -> 417.04).
        // If total ≈ 2 * commission_secondary, use only commission_secondary once.
        const rawTotal = parseFloat(object?.commission_total);
        const rawSecondary = parseFloat(object?.commission_secondary);
        const tolerance = 0.02;
        const isDuplicatedSingleFee = rawSecondary > 0 && rawTotal > 0 &&
          Math.abs(rawTotal - 2 * rawSecondary) < tolerance;
        const originalCommissionTotal = isDuplicatedSingleFee ? rawSecondary : object?.commission_total;
        const commissionSecondary = isDuplicatedSingleFee ? null : object?.commission_secondary;

        // AI may put Nordea Kauppasumma (gross+fees) into price_total; use quantity*price (Bruttosumma).
        const rawPriceTotal = parseFloat(object?.price_total);
        const rawQty = parseFloat(object?.quantity);
        const rawUnitPrice = parseFloat(object?.price);
        const rawCommission = parseFloat(originalCommissionTotal);
        const grossAmount = rawQty > 0 && rawUnitPrice > 0 ? rawQty * rawUnitPrice : null;
        const priceTotalIncludesFees = grossAmount != null && rawCommission > 0 && rawPriceTotal > 0 &&
          Math.abs(rawPriceTotal - (grossAmount + rawCommission)) < 0.05;
        const originalPriceTotal = priceTotalIncludesFees ? grossAmount : object?.price_total;
        const convertedPriceTotal = applyExchangeRate(originalPriceTotal);

        const convertedCommissionTotal = applyExchangeRate(originalCommissionTotal);

        setPreSetValues({
            ...defaultValues,
            broker_name: object?.broker_name,
            date_transaction: object?.date_transaction ? moment(object?.date_transaction).toDate() : new Date(),
            date_settlement: object?.date_settlement ? moment(object?.date_settlement).toDate() : new Date(),
            price: convertedPrice,
            original_price: object?.price,
            original_price_currency: object?.price_currency,
            price_total: convertedPriceTotal,
            original_price_total: originalPriceTotal,
            original_price_total_currency: object?.price_total_currency,
            quantity: object?.quantity,
            commission: object?.commission,
            commission_total: convertedCommissionTotal,
            original_commission_total: originalCommissionTotal,
            original_commission_total_currency: object?.commission_currency,
            notes: object?.notes,
            reference_code: object?.reference_code,
            state: object?.state,
            currency: object?.currency,
            // stock_market: object?.stock_market,
            value_total: object?.value_total,
            ticker_symbol: object?.related_model?.ticker_symbol,
            related_model_id: object?.related_model_id,
            related_model_type: object?.related_model_type,
            stock:{id: object?.related_model_id, value:object?.related_model_id, label: object?.related_model?.name, ticker_symbol: object?.related_model?.ticker_symbol, stock_market: object?.related_model?.stock_market,stockMarket: object?.related_model?.stock_market, currency_label: object?.related_model?.currency_label},
            type: object?.type,
            currency_exchange_rate: exchangeRate,
            quantity_polygon: object?.quantity_polygon,
            security_name_polygon: object?.security_name_polygon,
            security_ticker_symbol_polygon: object?.security_ticker_symbol_polygon,
            price_polygon: object?.price_polygon,
            commission_polygon: object?.commission_polygon,
            total_amount_polygon: object?.total_amount_polygon,
            notes_polygon: object?.notes_polygon,
            date_polygon: object?.date_polygon,
            type_polygon: object?.type_polygon,
            date_settlement_polygon: object?.date_settlement_polygon,
            broker_polygon: object?.broker_polygon,
            reference_code_polygon: object?.reference_code_polygon,
            quantity_page: object?.quantity_page,
            security_name_page: object?.security_name_page,
            security_ticker_symbol_page: object?.security_ticker_symbol_page,
            price_page: object?.price_page,
            commission_page: object?.commission_page,
            total_amount_page: object?.total_amount_page,
            notes_page: object?.notes_page,
            date_page: object?.date_page,
            transaction_type_page: object?.transaction_type_page,
            date_settlement_page: object?.date_settlement_page,
            broker_page: object?.broker_page,
            reference_number_page: object?.reference_number_page,
            currency_exchange_rate_direction: object?.currency_exchange_rate_direction,
            commission_secondary: commissionSecondary,
            commission_secondary_page: object?.commission_secondary_page,
            commission_secondary_polygon: object?.commission_secondary_polygon,
            // quantity_hover: "false"


  

    
            
            
          });
            // setPreSetValues(
            //     ...defaultValues,
            


            // )
        
    }
  }, [objectId, modalOpen])
  
  if (loading) {
    return (
      <Container fluid className="d-flex justify-content-center align-items-center">
        <Spinner className="mt-3" />
      </Container>
    )
  }

  return (
    <>

    <PurchaseEditFormik 
      t={t}
      history={history}
      preSetValues={preSetValues}
      notify={notify}
      objectId={objectId}
      addOption={addOption}
      currencyDate={currencyDate}
      setCurrencyDate={setCurrencyDate}
      portfolio={portfolio}
      stocks={stocks}
      stockMarket={stockMarket}
      setStockMarket={setStockMarket}
      totalValue={totalValue}
      setTotalValue={setTotalValue}
      totalValueEur={totalValueEur}
      setTotalValueEur={setTotalValueEur}
      stocksLoading={stocksLoading}
      currentStock={currentStock}
      findeObject={findObject}
      setInvestmentType={setInvestmentType}
      investmentType={investmentType}
      setFundType={setFundType}
      fundType={fundType}
      setFilters={setFilters}
      setBatchs = {setBatchs}
      batchs = {batchs}
      batchRatio = {batchRatio}
      setBatchRatio = {setBatchRatio}
      securityTargetRate={securityTargetRate}
      setSecurityTargetRate={setSecurityTargetRate}
      portfolioSourceRate={portfolioSourceRate}
      setPortfolioSourceRate={setPortfolioSourceRate}
      securitySourceRateDate={securitySourceRateDate}
      setSecuritySourceRateDate={setSecuritySourceRateDate}
      transaction_count={transaction_count}
      maxSaldo={maxSaldo}
      setMaxSaldo={setMaxSaldo}
      batchWac={batchWac}
      setBatchWac={setBatchWac}
      setFiles={setFiles}
      files={files}
      trxFiles={trxFiles}
      setTrxFiles={setTrxFiles}
      handleFileUpload={handleFileUpload}
      object={object}
      handleResolve={rest.handleResolve}
      setTransactionType={setTransactionType}
      transactionType={transactionType}

      {...rest} 
    />
    </>
  )
  

}
  

export default SaleEditView;
